
let chart = null;


let globesChart = {
    arrIndicatorsData: [],
    arrNoDayTypes: [16, 21],
    arrNoVolumeGraph: [20,21,16,46],

    backgroundColor: '#f3f8fc',

    chartHeight: '',    
    currentInstrument: undefined,
    colorRed: '#EA5641',
    colorGreen: '#5CAB63',
    chartType: 'line',

    dataGroupingObj: undefined,
    
    defaultDownload: 'img',
    defaultDataGroupingUnit: [['minute', [3]]],
    defRangeSelector: 0,
    
    defaultChartHeight: '70%',
    defaultSmallChartHeight: '20%',
    defaultSmallChartHeightPercent : 0.2,
    defaultSmallChartTop: '80%',
    defaultSmallChartTopPercent: 1.15,

    dateTimeLabelFormats: {     
        millisecond: ['%A, %b %e, %H:%M','','%A, %b %e, %H:%M'],
        second: ['%A, %b %e, %H:%M','','%A, %b %e, %H:%M'],        
        minute: ['%A, %b %e, %H:%M', '', '%A, %b %e, %H:%M'],
        hour: ['%A, %b %e, %H:%M', '', '%H:%M'],
        day: ['%A, %b %e, %Y', '', '%A, %b %e, %Y'],
        week: ['%A, %b %e, %Y', '', ''],
        month: ['%B %Y', '', '%B %Y'],
        year: ['%Y', '', '%Y']
    },

    intervalId: undefined,
    indicators: [],
    indicatorsParams: [],
    isInputClick: false,
    isResolutionClick: false,
    isAddInstrumentClick: false,
    isRangeSelectorClick: false,
    isDayRangeDisabled: false,
    isWeekRangeDisabled: false,

    legends: [],
    
    maxSymbols: 5,
    maxPoints: 130,
    minutes: 3,// 15,
    mode: {
        updateInput: Mode == '' ? true : false,
        saveState: Mode == '' || Mode == 'comparison' ? true : false,
        useComparisonSymbols: Mode == 'comparison' || Mode == 'simpleComparison' || Mode == 'articleComparison' ? true : false,
        isNavigator: Mode == '' ? true : false,
        isIndicators: Mode == '' ? true : false,
    },

    navigatorSeriesData: [],

    options : {},

    period: '1d',
    prevExtremes: undefined,    
    pointFormatInValue: '<span style="color:{series.color}">{series.name}</span>: <b style="direction:ltr">{point.y:0f}</b><br/>',
    pointFormatInPercent: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.change}%)<br/>',
    plotOptionsSeries : {},

    rangeSelector: undefined,
    resolutions: 'month,week,day,hour,minute'.split(','),

    seriesOptions: [],
    selResolution: undefined,
    symbols: [], 
    
    tab: '',

    yAxisOptions: [],

    addInstrumentToComparison: function (instParam) {
        let me = this;    

        let dataGroupingObj = undefined,
            min = chart.xAxis[0].min,
            max = chart.xAxis[0].max,
            type = '',
            count = 1,
            period = '',
            top = '',
            graphType = me.chartType; 

        if (me.symbols.indexOf(instParam) > -1) {
            alert('המניה שנבחרה כבר קיימת בגרף')
            return false;
        }
        me.isAddInstrumentClick = true;
        if (me.symbols.length == this.maxSymbols) {
            this.showMaxSymbolsAlert("באפשרותך להציג עד " + this.maxSymbols + " מניות באותו זמן");
           // alert("באפשרותך להציג עד "+ this.maxSymbols +" מניות באותו זמן")
            return;
        }
        me.symbols.push(instParam);

        
        me.updateState({
            symbols: me.symbols
        });

        if (me.rangeSelector != undefined) {
            count = me.rangeSelector.count,
            type = me.rangeSelector.type;
            dataGroupingObj = this.getDataGroupingObject_ByRangeSelector(type, count);
            period = type == 'day' || type == 'week' ? type : 'all';
        } else {
            if (me.selResolution != undefined) {
                dataGroupingObj = this.getDataGroupingObj_ByResolution(me.selResolution.res, me.selResolution.count);
                top = me.maxPoints;
            } else { //input change or navigator
                let unit = me.getUnitFromRangeStart(min, max),
                    count = unit == 'minute' ? 15 : 1;
                dataGroupingObj = me.getDataGroupingObj_ByResolution(unit, count);
            }
        }
        me.dataGroupingObj = dataGroupingObj;
        me.addInstrumentToOutsideTable(instParam)
        me.refreshAllData( dataGroupingObj, top, period, min, max, 'addInstrumentToComparison');        
    },


    addIndicator: function (t, s, oParams, aColors, yAxisId ) {
        
        let series = null,
            me = this,
            tooltipOptions = this.setTooltipFormater(me.currentInstrument.instrumentType, true, t.toLowerCase());

        if (arguments.length < 5)
            yAxisId = '';

            if (chart.series[0].type === 'line') {                
                this.changeGraphTypeClick('candlestick')
                me.updateState({
                    type: 'candlestick'
                });
            }

        series = {
            type: t.toLowerCase(),
            linkedTo: 'main',
            name: s.toUpperCase(),
            showInLegend: true,
            params: oParams,
            color: aColors[0],
            marker: { enabled: false },
            id: s + "_" + this.seriesOptions.length,
            tooltip: tooltipOptions
            
        };
        //set indicators multy colors
        if (aColors.length > 1) {
            switch (t) {
                case 'macd':
                    series.signalLine = {
                        styles: {
                            lineColor: aColors[1]
                        }
                    }
                    break;
                case 'bb': 
                    let color1 = this.convert2Rgba(aColors[0]);
                    series.fillColor = color1;
                    series.topLine = {
                        styles: {
                            lineColor: aColors[1]
                        }
                    }
                    if (aColors.length > 2) {
                        series.bottomLine = {
                            styles: {
                                lineColor: aColors[2]
                            }
                        }
                    }
                    break;
                default:
                    break;
            }
        }

        if (t != 'bb' && t != 'sma') {
            if (yAxisId != '') { //in case of just changgin params
                series.yAxis = yAxisId;
            } else {

                let newYAxisId = this.yAxis_add_new(t, s); //new indicator
                series.yAxis = newYAxisId;

                
            }
        }

        let cloneSeries = JSON.parse(JSON.stringify(series));
        cloneSeries.tooltipOptions = this.setTooltipFormater(me.currentInstrument.instrumentType, true, t.toLowerCase());

        chart.addSeries(cloneSeries);
        
        //for indicators: split tooltip
        if (this.indicatorsParams.length == 0) {
            chart.update({
                tooltip: {
                    share: false,
                    split: true
                }
            })
        }

        this.legendBuildAll();
        this.seriesOptions.push(series);
        this.indicatorsParams.push(series);

        if (this.indicators.indexOf(t) == -1)
            this.indicators.push(t);

        $("#selIndicatorWraper ul li[data-value='" + t + "']").addClass('selected')
    },

    addInstrumentToOutsideTable: function (instId) {
            let $outsideChkbox = $("#tblIndexInstruments tr td.tdInstrumentData[data-id='" + instId + "']")
            if ($outsideChkbox.length > 0) {
                $outsideChkbox.find( "input" ).prop('checked', true);
            }
    },

    afterSetExtremes: function (e) {
        let me = globesChart;
        if (e == undefined || (e.trigger != 'navigator' && me.isInputClick == false))
            return;
                 

        let min = Math.floor(e.min),
            max = Math.floor(e.max),           
            now = new Date();

        
        me.unSelectResolutionButton();
        me.unSelectRangeButton();            
        me.rangeSelector = undefined;   
        me.selectRangeCustomButton();

        let unit = me.getUnitFromRangeStart(min, max),
            count = unit == 'minute' ? 15 : 1,
            dataGroupingObj = me.getDataGroupingObj_ByResolution(unit, count);

        
               
        if (me.prevExtremes == undefined ||
            (me.prevExtremes.period == 'all' && (min < me.prevExtremes.dataMin || max > me.prevExtremes.dataMax) ||
             me.prevExtremes.period != 'all')
        ) {
  

            me.isInputClick = false;            
            me.refreshAllData( dataGroupingObj, '', '', min, max, 'afterSetExtremes');

        } else {      
            if (!me.isInputClick) {
                me.updateInputs(min, max)
            }

            if (chart.xAxis[0].series[0].points.length > me.maxPoints) {
                chart.xAxis[0].setDataGrouping(dataGroupingObj);                
                me.updateState({
                    dataGrouping: dataGroupingObj
                });
                me.dataGroupingObj = dataGroupingObj;
            }
            me.selectResolutionButton(dataGroupingObj);
            
            me.updateState({
                rangeSelector: me.rangeSelector,               
                min: min,
                max: max
            });
        }
    },

    

     afterRangeSelectorClick: function(e) { 
         let me = globesChart,
             data = chart && chart.series.length > 0 ? chart.series[0].options.data : undefined,
             dataLen = data != undefined ? data.length : -1,
             dataMin = dataLen > 0 ? data[0][0] : 0,
             dataMax = dataLen > 0 ? data[dataLen - 1][0] : 0,
             count = parseInt($(e.currentTarget).attr("data-count")),
             type = $(e.currentTarget).attr("data-type");
              
                  
            let sType = '';

            let now = new Date();
            let end = now.getTime();
            let max = end;
            let start = Math.round(me.calcRangeStartCalc(now, type, count).getTime());
            let currPeriod = '';
            let sTop = '';
            let sRes = '';
            let dataGroupingObj = this.getDataGroupingObject_ByRangeSelector(type, count);            

            if (type == 'day') {
              sType = "&type=day";
              currPeriod = 'day';
            } else {
              if (type == 'week') {
                sType = "&type=week";
                currPeriod = 'week';
              } else {
                sType = "&type=all";
                currPeriod = 'all';
              }
            }

            

            if (me.prevExtremes != undefined && me.prevExtremes.period == currPeriod && (currPeriod == 'all' || end - me.prevExtremes.time < 120000)) {

                let xStart = dataMin > 0 ?  Math.max(start, dataMin) : start,
                    xEnd = dataMax > 0 ? Math.min(end, dataMax) : end;

                
                
                if (currPeriod == 'day' ) {                    
                    let dayExtremes = me.findDayExtremes();                                    
                    xStart = dayExtremes.min;
                    xEnd = dayExtremes.max;
                }

                chart.xAxis[0].setExtremes(xStart, xEnd);
                chart.xAxis[0].setDataGrouping(dataGroupingObj);
                me.selectResolutionButton(dataGroupingObj);
                me.dataGroupingObj = dataGroupingObj;
               
                chart.redraw();
                me.isRangeSelectorClick = false
                me.updateInputs(Math.max(start, dataMin), Math.min(end, dataMax))

                me.updateState({     
                    dataGrouping: dataGroupingObj,
                    min: xStart,
                    max: xEnd,
                    rangeSelector: me.rangeSelector,
                    selResolution: me.selResolution,
                });

              return;
            }
         

            chart.showLoading('טוען נתונים...');
                     
            let top = '';
                
         
            this.refreshAllData(dataGroupingObj, top, currPeriod, start, end, 'afterRangeSelectorClick');
    },

     
     buildVolumeSeries: function(data) {
            
            let volume = this.fillVolumeData(data);
                     
            return {
                type: 'column',
                name: instrumentName + '-נפח מסחר',
                data: volume,
                id: 'volume',
                yAxis: 2,
                decimals: 4,
                marker: {
                    enabled: false
                },
                color: Highcharts.defaultOptions.colors[0],
                showInLegend: false,
                compare: 'none',
                visible:  true
            }
     },
          
     buildIndicatoresArray: function () {
         let me = this;
        $.ajax({ "url": "/static/graphs/indicators/indicatorsList.js?v=1&callback=?", "dataType": "text" })
            .done(function (data) {
                me.arrIndicatorsData = JSON.parse(data);

                let $indicatorWraper = $("#selIndicatorWraper");
                $indicatorWraper.append("<ul></ul>");
                let template = "<li data-value='{0}'>{1}</li>"
                me.arrIndicatorsData.forEach(function (elem, index) {                     
                    $indicatorWraper.find("ul").append(template.replace("{0}", elem.id).replace("{1}", elem.label));
                });
                //$indicatorWraper.find("ul li[data-value='volume']").addClass("selected")

                $("#selIndicatorWraper ul li").click(function (e) {                        
                    me.graphicalAnalysisClick(e);
                    
                });
                    
            })
            .fail(function (jqXHR,textStatus, errorThrown) {
                console.log("fail to load indicators list: status" + textStatus + "  errpr: " + errorThrown);
            });
     },

     buildIndicatorForm: function (element) {
         let me = this;
         try {
             let templateIndicator = $("#templateIndicator").html();
             let templatePeriod = $("#templatePeriod").html();
             let templateColor = $("#templateColor").html();

             let indicatorType = element.id;
             let periodHtml = [];
             let colorHtml = [];             
             let colors = Highcharts.getOptions().indicatorsColors[indicatorType];
             let colorIndex = -1; //chart.series.length - 1;
             

             //fetch previeus selected values from exists indicators
             let filteredSeries = chart.series.filter((s) => s.userOptions.type == element.id),
                 existsParams = [];
             if (filteredSeries != undefined && Array.isArray(filteredSeries)) {
                 filteredSeries.forEach(function (objItem, index) {
                     existsParams.push(filteredSeries[index].userOptions.params.period);
                 });
             }
             //--
             
             element.htmlFields.forEach(function (arrItem, index) {
                let defVal = existsParams.length > index ? existsParams[index] : element.params[arrItem.fieldName]                
                periodHtml.push(
                    templatePeriod.replace("{period}", arrItem.label)
                    .replace("{fieldName}", arrItem.fieldName)
                    .replace("{index}", index)
                    .replace("{def}", defVal)
                );

                for (let i = 0; i < arrItem.colors.length; i++) {
                    colorIndex++;
                    colorHtml.push(templateColor.replace("{color}", arrItem.colors[i])
                        .replace("{colorIndex}", colorIndex)
                        .replace(/\{colorVal\}/g, colors[colorIndex]));
                }
            });


            let indicatorHTML = templateIndicator.replace("{title}", element.title)
                .replace("{description}", element.description)
                .replace("{periods}", periodHtml.join(''))
                .replace("{colors}", colorHtml.join(''));

            //build the indicator form
            $("section.indicatorForm").html(indicatorHTML)
            $("section.indicatorForm").attr('data-indicator-id', element.id);
            if (element.id == 'macd') {
                $("section.indicatorForm h2").css("font-size", "16px");
            }

            //events
            $("section.indicatorForm h2 span.close , section.indicatorForm input.cancel").click(function () {
                $(window).off('scroll')
                $("section.indicatorForm").hide()
            });

            $("ul.fields li span.add").mousedown(function () {
                let spanNum = $(this).parent().find("input.num")
                me.intervalId = setInterval(() => {
                    let num = parseInt(spanNum.val());
                    if (num < 201)
                        spanNum.val(num + 1);
                }, 100);               
            });
            $("ul.fields li span.add").mouseup(function () {
                let spanNum = $(this).parent().find("span.num");
                clearInterval(me.intervalId);                
            });
            $("ul.fields li input.num").change(function () {
                let value = $(this).val();
                if (isNaN(value)) {
                    $(this).val(0);
                    return;
                }
                value = parseInt(value);
                if (value < 0 || value > 200) {
                    $(this).val(0);
                    return;
                }

            });

            $("ul.fields li span.substract").mousedown(function () {
                let spanNum = $(this).parent().find("input.num");
                me.intervalId = setInterval(() => {
                    let num = parseInt(spanNum.val());
                    if (num > 0)
                        spanNum.val(num - 1);
                }, 100);
            });
            $("ul.fields li span.substract").mouseup(function () {
                let spanNum = $(this).parent().find("span.num");
                clearInterval(me.intervalId);                
            });

            $("section.indicatorForm input.OK").click(function (e) {
                let fields = $("ul.fields li input.num").slice(0)
                let linesColors = $("ul.linesColors li input.squere").get();

                let indicatorId = $("section.indicatorForm").attr("data-indicator-id")
                let arrItem = globesChart.arrIndicatorsData.find((elem) => elem.id == indicatorId); //find indicator defenition in JSON arr

                let oParam = {};//create indicator params
                let arrPeriods = [];
                let gc = globesChart;

                Object.getOwnPropertyNames(arrItem.params).forEach(
                    function (val, idx, array) {
                        if ($("ul.fields li input." + val).length > 0) {
                            let newVal = $("ul.fields li input." + val).val()
                            let iNewVal = parseInt(newVal)
                            oParam[val] = isNaN(iNewVal) ? newVal : iNewVal;

                            arrPeriods.push(newVal);
                        } else {
                            let newVal = arrItem.params[val]
                            oParam[val] = newVal;

                            arrPeriods.push(newVal);
                        }
                    }
                );
                let arrColors = linesColors.map((x) => {
                    return x.value;
                });

                let indicatorName = indicatorId +
                    (arrPeriods.length > 0
                        ? '(' + arrPeriods.splice(1, arrPeriods.length - 1).join(',') + ')'
                        : ''
                    );

                try {

                    let indicatorType = indicatorId,
                        yAxisId = gc.removePerviousIndicatorsSeries(indicatorType);

                    if (indicatorId === 'sma') {

                        //make our own triple sma
                        Object.keys(oParam).forEach(function (key, index) {
                            if (index > 0 &&  oParam[key] > 0) {
                                let periodKey = Object.keys(oParam)[index],
                                    periodVal = Object.values(oParam)[index],                                    
                                    newColors = [arrColors[index - 1]],
                                    newParams = { 'index': oParam.index, 'period': periodVal };

                                    indicatorName = indicatorId +'(' + periodVal + ')'

                                
                                gc.addIndicator(indicatorId, indicatorName, newParams, newColors, yAxisId);
                            }
                        });

                    } else {
                        gc.addIndicator(indicatorId, indicatorName, oParam, arrColors, yAxisId);
                    }

                     //save state
                    let seriesIndicators = gc.getIndicatorsSeriesParams();
                    gc.updateState({
                        indicators: gc.indicators,
                        indicatorsParams: seriesIndicators,
                        yAxisOptions: gc.yAxisOptions,
                        //seriesOptions: gc.seriesOptions,
                        chartHeight:  gc.chartHeight,
                    });
                    
                    

                    
                } catch (e) {
                    console.log(e);
                    alert('מצטערים, ארעה תקלה ביצירת אינדיקטור');
                }

                $("section.indicatorForm").html('').hide();
            });

            return true

        } catch (e) {
            console.log('fail building indicator: ' + e.description);
            return false;
        }
     },

     btnDeleteClick: (obj) => {

     },

     changeGraphTypeClick: function(type){            
         if ( this.isCompareMode() && type == 'candlestick') {
                return;
            }
         
            this.changeGraphType(type);
            
                  
     },      
         
     copyArr: function (a) {
         let arr = new Array();
         a.forEach(function (item, index) {
             let innerArr = new Array();
             for (let i = 0; i < item.length; i++) {
                 innerArr.push(item[i]);
             }
             arr.push(innerArr);
         });
         return arr;
     },
     

     changeGraphType: function(type){        
         if (chart != undefined) {
             if (this.currentInstrument != undefined && !(this.currentInstrument.instrumentTypeId == 21 || (this.currentInstrument.instrumentTypeId == 20 && this.rangeSelector.type == 'week' && type == "candlestick"))  ) {    //represntetive Currency

                 this.chartType = type;
                 
                 this.seriesOptions[0].type = type;
                 this.seriesOptions[0].data = type === 'candlestick' ? this.currentInstrument.orgData : this.currentInstrument.mapedData;
                 this.seriesOptions[0].color = type === 'candlestick' ? this.colorRed : Highcharts.defaultOptions.colors[0];
                 this.seriesOptions[0].tooltip = this.setTooltipFormater(this.currentInstrument.instrumentType, false, type);                
                
                let baseSeries = this.seriesOptions.find(serios => serios.id == 'baseRate');
                if (baseSeries != undefined) {
                     baseSeries.visible = type === 'candlestick' ? false : true;
                }
                chart.update({ series: this.seriesOptions }, true);

                this.legendBuildAll();

                this.updateState({
                    type: type,
                    seriesOptions: this.seriesOptions
                 });

                 this.changeGraphTypeButton(type);
            }
        }
     },

     changeGraphTypeButton: function(type){
         $(".graphType span").removeClass("active");
         $(".graphType span." + type).addClass("active");
         
     },

	 charHeight: function charHeight() {
        return this.isMobile() ? 13 : 8;
     },

     convert2Rgba: function(color) {
        let arrC = color.replace(/#(\w{2})(\w{2})(\w{2})/, '$1,$2,$3').split(',');
        if (Array.isArray(arrC)){
            let arrDec = arrC.map(function (value, index) {
                return parseInt(value, 16);
            });
            return 'rgba(' + arrDec[0] +',' + arrDec[1] +','+ arrDec[2] +',0.15)'
        }
        return '';
    },

    calcRangeStart: function(now, e) {//zmira: isRelevant ?
            let type = '',
                count = 0;

            if (e != undefined) {
                type = e.rangeSelectorButton.type
                count = e.rangeSelectorButton.count
            } else {
                let selected = chart.rangeSelector.selected;
                type = chart.options.rangeSelector.buttons[selected].type,
                count = chart.options.rangeSelector.buttons[selected].count;
            }
            return this.calcRangeStartCalc(now, type, count);
        },

    calcRangeStartCalc: function(now, type, count) {
        let start;
        let dayStart;
            switch (type) {
                    case 'day':
                        start = this.calcDayStart(now, count);
                        break;
                    case 'week':
                        start = this.calcWeekStart(now);
                        break;
                    case 'month':
                        dayStart = new Date( now.getFullYear(), now.getMonth(), now.getDate());
                        start = this.calcMonthStart(dayStart, count);
                        break;
                    case 'year':
                        dayStart = new Date( now.getFullYear(), now.getMonth(), now.getDate());
                        start = this.calcYearStart(dayStart, count);
                        break;
                    case 'all':
                        dayStart = new Date( now.getFullYear(), now.getMonth(), now.getDate());
                        start = this.calcYearStart(dayStart, 10);
                        break;
            }
            return start;
        },

    calcDayStart: function(now, dayCount){
           
        try {
            let arrDate = lastTradeDate.split(' ')[0];
            let arrD = arrDate.split('-')
            //return new Date(parseInt(arrD[0]), parseInt(arrD[1])-1 , parseInt(arrD[2]))
            return new Date(lastTradeDate);

        } catch (e) {
            //console.log("in calcDayStart exception: " + e)
            let dayMillSec = 1000 * 3600 * 24;
            if (now.getHours() <= 9 && now.getMinutes() <= 30 )
                return this.createDate(now, -1 * dayCount, 0, 0);

            return new Date(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 9, 30, 0).getTime() - ((dayCount-1) * dayMillSec))
        }
    },

    calcWeekStart: (now) => globesChart.createDate(now, -7, 0, 0),

    calcMonthStart: (now, count) => globesChart.createDate(now, 0, -1* count, 0),
  
    calcYearStart: (now, count) => globesChart.createDate(now, 0, 0, -1*count),

    
   
    createDate: (date, days, months, years) => {      
        let d = date;        
        d.setDate(date.getDate() + days);
        d.setMonth(date.getMonth() + months);
        d.setFullYear(date.getFullYear() + years);
        return d;    
    },

    
    changeTheme: function () {
        

        let $obj = $(".graphFrame"),
            
            min = chart.xAxis[0].min,
            max = chart.xAxis[0].max,
            chartType = this.chartType,
            dataGroupingObj = this.dataGroupingObj,
            period = this.getPeriod(),
            me = this,
            value ;

        if ($obj.hasClass("dark")) {
            $(".graphFrame").removeClass("dark");
            Highcharts.setOptions(Highcharts.themeLight);
            chart.update(Highcharts.themeLight);
            value = 'light';
            
        } else {
            $(".graphFrame").addClass("dark");
            // Apply the theme                    
            Highcharts.setOptions(Highcharts.themeDark);
            chart.update(Highcharts.themeDark);
            value = 'dark';
        }

        this.updateState({ theme: value });
        

        me.refreshAllData(me.dataGroupingObj, "", period, min, max, 'changeTheme');

        return;
        
        
    },

    createChart: (options) => {
            return Highcharts.stockChart('container', options);
    },
        

    changeResolution: function(unit, icount, redraw){
            
        let dataGrouping = {
           
            enabled: true,
            force: true,
            units: [[unit, [icount]]],            
            dateTimeLabelFormats: this.dateTimeLabelFormats,
        };

        //options.plotOptions.series.dataGrouping = dataGrouping;
        me.plotOptionsSeries.dataGrouping = dataGrouping;
        me.options.plotOptions.series = me.plotOptionsSeries;

        chart.xAxis[0].setDataGrouping(dataGrouping, true);
    },

     chartLoadNew: function () {

    },

     chartRender: function () {
            
     },

     creditPosition: function (obj) {
            let windowWidth = window.innerWidth,
                operandY, operandX, x, y, imgH, imgW,
                s_mode;


            if (globesChart.isFullPage()) {
                if (windowWidth > 1300) {
                    operandY = 0.55;
                    operandX = 0.9;
                    imgW = 103;
                    imgH = 31;
                } else {
                    operandY = 0.47;
                    operandX = 0.84;
                    imgW = 103;
                    imgH = 31;
                }
            } else {

                if (Mode == 'articleComparison') {
                    if (typeof (qsMobile) != 'undefined' && qsMobile == "true")
                        s_mode = 'small';                    
                } else {
                    s_mode = Mode;
                }

                switch (s_mode) {                    
                    case 'small':                    
                        operandY = 0.5;
                        operandX = 0.78;
                        imgW = 66;
                        imgH = 20;
                        break;
                    case 'comparison':
                    case 'simpleComparison':
                        operandY = 0.56;
                        operandX = 0.77;
                        imgW = 103;
                        imgH = 31;
                         break;
                    default:
                        operandY = 0.475;
                        operandX = 0.825;
                        imgW = 103;
                        imgH = 31;
                        break;
                }
            }        
            
            y = Math.floor(obj.chartHeight * operandY);
            x = Math.floor(obj.chartWidth * operandX);

            return {
                x: x,
                y: y,
                width: imgW,
                height: imgH,
            }
        },

     chartLoad: function () {

         if (Mode == 'articleComparison') {
             var trading_snapshot = top.document.getElementsByClassName("trading_snapshot")
             if (trading_snapshot != null) {
                 $(trading_snapshot).each(function (index, tradingItem) {
                     $(tradingItem).find("table tr td span.squere").each(function (index, item) {
                         $(item).css("backgroundColor", Highcharts.defaultOptions.colors[index]);
                     });
                 });
             }
             return;
         }
            
        let objPos = globesChart.creditPosition(this);
        let img = this.renderer.image("https://images.globes.co.il/images/portal/graphs/globes.svg", objPos.x , objPos.y , objPos.width, objPos.height)
        img.add();            
            
        if (Mode == '') {
        let currYear = new Date().getFullYear(),
            range = "2008:" + currYear.toString();            
            $(".customRangeSelectorInputs input").datepicker({
                changeYear: true,
                yearRange: range,
            });
            $(".customRangeSelectorInputs input").datepicker($.datepicker.regional["he"]);
        }
     },

     disabledRangeDay: function () {
         $("#rangeDay").hide();
         $("#resolutionMinute3, #resolutionMinute , #resolutionHour").off("click");
         $("#resolutionMinute3, #resolutionMinute , #resolutionHour").addClass("notactive")
         this.isDayRangeDisabled = true;
    },
    disabledRangeWeek: function () {
        $("#rangeWeek").hide();
        $("#resolutionMinute3, #resolutionMinute , #resolutionHour").off("click");
        $("#resolutionMinute3, #resolutionMinute , #resolutionHour").addClass("notactive")
        this.isWeekRangeDisabled = true;        
    },
    

     findExchangeExtraTime: function(timeString) {
         if (timeString != '') {
             let d = new Date(timeString);
             return d.getTime();
         }       
         return 0;

     },
     findDayExtremes: function() { //by instrument tradeStage
         let todayStartTime = this.calcDayStart().getTime();
         let orgData = this.currentInstrument.orgData;
         let exchageStartTime = this.findExchangeExtraTime(exchangeStartTime);
         let exchageEndTime = this.findExchangeExtraTime(exchangeEndTime);
         let arrDataFromTodayT = orgData.filter((arr, index) => { return arr[0] > todayStartTime && (arr.length < 7 || arr[6] == 'T') });
         let arrDataFromTodayE = orgData.filter((arr, index, orgArray) => { return arr[0] > todayStartTime && (arr.length == 7 && arr[6] == 'E') });                                    
         let xStart = feeder == 0 && arrDataFromTodayT.length > 0 ? arrDataFromTodayT[0][0] : (exchageStartTime > 0 ? exchageStartTime : todayStartTime);
         let xEnd =  feeder == 0 && arrDataFromTodayE.length > 0 ? arrDataFromTodayE[0][0] : (exchageEndTime > 0 ? exchageEndTime : todayStartTime + (9*60*60*1000));
         //let xEnd =  exchageEndTime > 0 ? exchageEndTime : (todayStartTime + (18 * 60 * 60 * 1000));
        return { min: xStart, max: xEnd };
     },

     findMinSeriesData: function(p) {
         let arrDataMin = this.seriesOptions.map((series, index) => { return [index , series.data[0][0]] });
         let index = arrDataMin.sort((a, b) => {
             let subset = a[0] - b[0];
             if (subset < 0) return -1;
             if (subset > 0) return 1;
             return 0;
         })[0];
         return index
     },


     fillVolumeData: function(data) {
         let maxVol = 0,
             volume = [];

         for (let i = 0; i < data.length; i++) {
            let time = data[i][0];
            let vol = data[i][5];
            vol = vol != undefined && vol > maxVol ? vol : maxVol;
            volume.push([time, Math.floor(parseFloat(vol))]);
         }

         return volume;
     },

     getChartHeight: function(session) {
         let isFullPage = this.isFullPage(),
             num;

         if (typeof pageDefaultHeight != 'undefined')
             return pageDefaultHeight + 'px'

         if (this.isMobile())
             num = 13;
         else {
             if (!isFullPage && session != undefined && session.chartHeight != '')
                 return session.chartHeight;

             if (!isFullPage && this.chartHeight != '')
                 return this.chartHeight;

             if (this.isFullPage())
                 num = 7 
             else
                 
                    num = 8
         }
         return (num /16 * 100) + '%'
     },

        getIndicatorColors: function (item) {
            let t = item.type,
                aColors = [];
            aColors.push(item.color);

            switch (t) {
                case 'macd':
                    aColors.push(series.signalLine.styles.loneColor);                
                    break;
                case 'bb':
                    aColors.push(series.topLine.styles.lineColor);
                    aColors.push(series.bottomLine.styles.lineColor);
                    break;
                default:
                    break;
            }
            return aColors;
        },

        
        getPanning: () => { return true
            if (Mode && Mode == 'small')
                return true;
            else
                return false;
        },

        getTypeSession: function(obj){
            let objType = obj != undefined ? obj.type : undefined;
            let type = objType != undefined && Mode == ''
                ? objType
                : this.chartType;
                //: (chart != undefined && chart.series != undefined && chart.series.length > 0
                //    ? chart.series[0].type
                //    : 'line'
                //);
            //this.changeGraphTypeButton(type);
            return type;
        },
        
        getRangeButton: function(session){
            let range = '';
            if (session && session.rangeSelector) {
                range = session.rangeSelector;
            }else {
                if (chart != undefined)
                    range = chart.options.rangeSelector.selected;
                else
                    range = this.defRangeSelector;
            }
            if (range > -1) {
                this.rangeSelectorGetAll().eq(range).addClass("selected")
            }

            return range;
        },

        getPeriod: function(session){            
            if (session && session.prevExtremes != undefined && session.prevExtremes.period) {
                return session.prevExtremes.period;
            } else {
                if (this.prevExtremes != undefined && this.prevExtremes.period != null ) {                    
                    return this.prevExtremes.period;           
                }
                else {
                    //return this.defaultPeriod;
                    var rangeType = this.rangeSelectorGetAll().eq(this.defRangeSelector).attr("data-type");
                    return rangeType == 'day' || rangeType == 'week' ? rangeType : 'all';
                }
            }
        },

        getInputMinMAx: function (session, prop ) {
            if (session) {
                if (prop === 'min')
                    return session.inputMin;
                if (prop === 'max')
                    return session.inputMax;                
            } else {
                return null;
            }
        },

        getAxisMinMAx: function (session, prop ) {
            if (session) {
                if (prop === 'min')
                    return session.min;
                if (prop === 'max')
                    return session.max;                
            } else {
                return null;
            }
        },

        getDataGrouping: function (session) {
            if (session && session.dataGrouing != undefined) {
                return session.dataGrouing;
            }
            return {

            };
        },

        getDataGroupingUnit: function(session){
            if (session && session.dataGrouingUnit.length > 0) {
                return session.dataGrouingUnit.length
            } else {
                return this.defaultDataGroupingUnit;
            }
        },
						
		getDataUrl: function(instrumentid, feeder, type, isFirst, start, end, top, resolution) {    
            let navFirstParam = Mode != undefined && this.mode.isNavigator == true && type != 'all' && isFirst ? '&f=1' : '',
                startParam = arguments.length < 5 ? '' : '&start=' + start,
                endParam = arguments.length < 6 ? '' : '&end=' + end,
                topParam = arguments.length < 7 ? '' : '&top=' + top,
                resParam = arguments.length < 8 ? '' : '&resolution=' + resolution,
                dataFileName =  'instrumentInfo5';
                
            return '/portal/Graphs/data/' + dataFileName + '.ashx?symbol=' + instrumentid + '|' + feeder + '&source=2&type=' + type + navFirstParam + startParam + endParam + topParam + resParam;
        },

        getDataUrlParams: function(instrumentid, feeder, symbol, type, isFirst, start, end, top, resolution) {
            let instrumentTypeId = $("#hidGraphTypeId").val(),
                exchange = $("#hidGraphExchange").val(),                
                isBond = $("#hidIsBond").val() == "true",
                isOption = $("#hidIsOption").val() == "true",
                isIndex = $("#hidIsIndex").val() == "true",
                secret = '';

            if (typeof (user_id) != 'undefined' && user_id != undefined && user_id > 0) {
                try {
                    secret = document.cookie.split(';').filter(function (c) { return c.match(/^\s*Session=\d+x\d+/) })[0].split('=')[1];
                    secret = secret.split("x")[0];
                }
                catch (err) {
                }
            } 

                

            let navFirstParam = Mode != undefined && this.mode.isNavigator == true && type != 'all' && isFirst ? '1' : '0',
                startParam = arguments.length < 5 ? '' : start,
                endParam = arguments.length < 6 ? '' : end,
                topParam = arguments.length < 7 ? '' : top,
                resParam = arguments.length < 8 ? '' : resolution,
                sourceParam = Mode == 'articleComparison' ? 1 : 2;
               
                urlParam = feeder == "1" ? '/portal/Handlers/GTOGraphForeign.ashx' : '/portal/Handlers/GTOGraph.ashx';

            return {
                url: urlParam ,
                data: {
                    "symbol" : instrumentid + "|" + feeder + "|" + symbol,
                    "instrumentId" : symbol,
                    "feeder" : feeder,
                    "isRealTime": rt,
                    "f" : navFirstParam,
                    "start" : startParam,
                    "end" : endParam,
                    "top": topParam,
                    "resolution": resParam,
                    "isRealTime": rt,
                    "source": sourceParam,
                    "type": type,
                    "instrumentTypeId": this.symbols.length == 1 ? instrumentTypeId : "0",
                    "userId": (typeof (user_id) != 'undefined' ? user_id : 0),
                    "secret": secret
                }
            }
                //'/portal/Graphs/data/' + dataFileName + '.ashx?symbol=' + instrumentid + '|' + feeder + '&source=2&type=' + type + navFirstParam + startParam + endParam + topParam + resParam;
        },
	/*	
		getSelectedTypeAndPeriod: function(e) {
            let sType = '',
                currPeriod = '';                
            
            if (e == undefined)
                selectedRangeText = chart.options.rangeSelector.buttons[chart.rangeSelector.selected].text
            else
                selectedRangeText = e.rangeSelectorButton.text

            switch (selectedRangeText) {
                case "1d":
                    sType = "&type=day";
                    currPeriod = 'day';
                    break;
                case '1w':
                    sType = "&type=week";
                    currPeriod = 'week';
                    break;
                default:
                    sType = "&type=all";
                    currPeriod = 'all';
                    break
            }

            return {
                type: sType,
                period: currPeriod
            }
        },
*/
        getResolutionInMilisec: (unit, count) => {
            let milSecInWeek = 1000 * 60 * 60 * 24 * 7;
            let milSecInDay = 1000 * 60 * 60 * 24;
            let milSecInHour = 1000 * 60 * 60;
            let milSecInMin = 1000 * 60;

            switch (unit) {
                case 'minute':
                    return milSecInMin * count;
                case 'hour':
                    return milSecInHour * count;
                case 'day':
                    return milSecInDay * count;
                case 'week':
                    return milSecInWeek * count;
                default:
                    return milSecInDay * 30 * count;                
            }
        },

        getUnitFromRangeStart: function (startTime, endTime) {

            let totalPeriod = endTime - startTime;
                        
            let weekAgo = this.createDate(this.prevDay(endTime), -7, 0, 0);
            let m2Ago = this.createDate(this.prevDay(endTime), 0, -2, 0);
            let m3Ago = this.createDate(this.prevDay(endTime), 0, -3, 0);
            let m6Ago = this.createDate(this.prevDay(endTime), 0, -6, 0);
            let yAgo = this.createDate(this.prevDay(endTime), 0, 0, -1);
            let y3Ago = this.createDate(this.prevDay(endTime), 0, 0, -3);

            let milSecInWeek = 1000 * 60 * 60 * 24 * 7;
            let milSecInDay = 1000 * 60 * 60 * 24;
            let milSecInHour = 1000 * 60 * 60;
            let milSecInMin = 1000 * 60 ;
            let periodInMin = Math.round((endTime - startTime) / milSecInMin);
            let periodInHour = Math.round((endTime - startTime) / milSecInHour);
            let periodInDays = Math.round((endTime - startTime) / milSecInDay);
            let periodInWeeks = Math.round((endTime - startTime) / milSecInWeek);
            
            
            
            if (startTime >= weekAgo.getTime()) {
                return 'minute';
            } else if (startTime >= m2Ago.getTime()) {
                return periodInMin > this.maxPoints ? 'hour' : 'minute';
            } else {
                let weekendsDays = parseInt(periodInDays / 7 * 2);
                periodInDays = periodInDays - weekendsDays;

                if (periodInDays <= this.maxPoints )
                    return 'day';
                else {
                    return periodInWeeks > this.maxPoints ? 'month' : 'week';
                }
            }
            
           
        },
        
        getIndicatorsSeriesParams: function () {
            return this.seriesOptions.filter((s) => { return s.type != 'line' && s.type != 'candlestick' && s.type != 'column'  })           
        },

		
        getDataGroupingObj_ByResolution: function (type, count) {
            //handle - dayRangeDisabled Or weekRangeDisabled - end with the same units type
            if ((this.isDayRangeDisabled || this.isWeekRangeDisabled) && (type === 'minute' || type === 'hour' )) {
                type = 'day';
                count = 1;
            }

            let isEnabled = !( parseInt(count) === 3 && type === 'minute');
            return {
                enabled: isEnabled ,
                forced: true,
                units: [
                    [type, [count]]
                ],                       
                dateTimeLabelFormats: this.dateTimeLabelFormats, 
               // approximation: this.getApproximation(chart.series[0].type)
            }   
        },
  
		
		getDataGroupingObject_ByRangeSelector: function (type, count) {

            //let graphType = this.getTypeSession();
            let units = this.getUnitByRange(type, count); 

            switch (type) {
                case 'day':
                    return {
                        enabled: false,
                        forced: false,
                        units: units,
                        dateTimeLabelFormats: this.dateTimeLabelFormats,
                    };
              case 'week':        
                return {
                  enabled: true,
                  forced: false,
                  units: units,
                  dateTimeLabelFormats: this.dateTimeLabelFormats, 
                };
              case 'month':        
                return {
                  enabled: true,
                  forced: false,
                  units: units,
                  dateTimeLabelFormats: this.dateTimeLabelFormats, 
                };
              case 'year':
                return {
                  enabled: true,
                  forced: false,
                  units: units,
                  dateTimeLabelFormats: this.dateTimeLabelFormats, 
                };
              case 'all':
                return {
                  enabled: true,
                  forced: false,
                  units: units,
                  dateTimeLabelFormats: this.dateTimeLabelFormats, 
                }
            }
          },

        getUnitByRange: function(range, count) {
            if (range == 'day')
              return [
                ['minute', [3]]
              ];
            if (range == 'week') {
                if (this.isDayRangeDisabled)
                    return [
                      ['day', [1]]
                    ];
                return [
                    ['minute', [15]]
                ];
            }
            if (range == 'month') {
              if (count == 1)
                return [
                  ['day', [1]]
                ];
              else
                return [
                  ['day', [1]]
                ];              
            }
            if (range == 'year') {
              if (count == 1)
                return [
                  ['week', [1]]
                  ];
              else
                   return [
                  ['month', [1]]
                  ];              
            } else
              return [
                ['month', [1]]
              ];
        },

        getOrdinal: function(top) {
            let currPeriod = this.rangeSelector != undefined ? this.rangeSelector.type : '';
            return (currPeriod == 'day' && top == "" ) ? false : true
        },
        
        graphicalAnalysisClick: function(e) {
            if (chart != undefined) {      
                let s = e.target.getAttribute("data-value"),
                    windowHeight = $(window).height();
                    
                
                let element = this.arrIndicatorsData.find((elem) => elem.id == s)
                if (element != null) {

                    //console.log('indicator found');
                    if (this.buildIndicatorForm(element)) {                        
                        let formHeight = $("section.indicatorForm").height(),
                            scrollTop = $(window).scrollTop(),
                            mid = scrollTop + Math.floor(windowHeight / 2);//- Math.floor(formHeight / 2);

                        $("section.indicatorForm").css('top', mid + 'px').show();

                        $(window).scroll(function (e) {
                            let scrollTop = $(window).scrollTop(),
                                mid = scrollTop + Math.floor(windowHeight / 2);//- Math.floor(formHeight / 2);
                                $("section.indicatorForm").css('top', mid + 'px')
                        });
                    }
                };   
            }
        },

        handleChangeResolution : function(unit, icount) { 
              if (chart == undefined || unit == '') {
      	          return
              }
     
              let me = this,
                  maxRange = chart.xAxis[0].max,
                  minRange = chart.xAxis[0].min,
                  range = this.getResolutionInMilisec(unit, icount),// chart.xAxis[0].minRange,                        
                  numOfPointsInNewResolution = (maxRange - minRange), // range,
                  dg = chart.series[0].options.dataGrouping,
                  units = dg != undefined ? dg.units : undefined,
                  currentUnit = units != undefined ? units[0][0] : '',
                  currentUnitIndex = this.resolutions.indexOf(currentUnit),
                  nextUnitIndex =  unit ==='minute' && icount == 3 ? 5  :this.resolutions.indexOf(unit),
                  dataGroupingObj = this.getDataGroupingObj_ByResolution(unit, icount);

              me.dataGroupingObj = dataGroupingObj;



              if (numOfPointsInNewResolution > this.maxPoints && nextUnitIndex > currentUnitIndex ) {                  
                  minRange = maxRange - (this.maxPoints * range)

                  this.unSelectRangeButton();
                  this.selectRangeCustomButton();
                  this.rangeSelector = undefined;

                  this.updateState({
                      dataGrouping: dataGroupingObj,
                      rangeSelector: this.rangeSelector,
                      selResolution: this.selResolution
                  });

                  let now = new Date(),
                      end = now.getTime(),
                      resParams = unit === 'minute' ? icount : unit.substring(0, 1);
                      

                  this.refreshAllData( dataGroupingObj, this.maxPoints, '', minRange , maxRange, 'handleChangeResolution') 

              } else {  
                  //no need for fresh data
                  chart.xAxis[0].setDataGrouping(dataGroupingObj, false);  

                  this.updateState({
                      dataGrouping: dataGroupingObj,
                      rangeSelector: this.rangeSelector,
                      selResolution: this.selResolution
                  });

                   chart.redraw();
                   globesChart.isResolutionClick = false;
              }
             
          },
        
        hideSeries: function(id, isActive){
             if (chart != undefined) {
                 let series = this.seriesOptions.find((series) => { return series.id == id });
                 if (series != undefined) {
                     series.visible = isActive ? true : false;
                     chart.update({
                         series: this.seriesOptions
                     })
                 }
             }
         },
         
         isCompareMode: function(){
            return (Mode == 'comparison' || Mode == 'simpleComparison' ||  Mode == 'articleComparison' || (this.symbols.length > 1 && (this.tab == 'compare' || Mode == 'small' || Mode == 'simpleComparison' || Mode == 'articleComparison' )));
         },

         isFullPage: () => {
             return location.href.toLowerCase().indexOf("instrumentgraph.aspx") > -1;
         },

         isMobile: function isMobile() {
                return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
                );
         },

         isVolumeVisible: function() {
             return (typeof (this.currentInstrument) != 'undefined' && this.currentInstrument.instrumentTypeId > 0 && this.arrNoVolumeGraph.indexOf(this.currentInstrument.instrumentTypeId) < 0) ||
                 (typeof (this.currentInstrument) == 'undefined' && this.arrNoVolumeGraph.indexOf(parseInt($("#hidGraphTypeId").val())) < 0);
         },

         isTooltipSharing: function () {
             return this.indicators.length == 0;
         },

         iconFullToggle: () => {
           // globesChart.localSessionSetData();
            if (location.href.toLowerCase().indexOf("instrumentgraph.aspx") == -1) {
                location.href = "/portal/graphs/instrumentgraph.aspx?instrumentid=" + instrumentid + "&feeder=" + feeder + "&mode=graph";
            } else {
                location.href = "/portal/instrument.aspx?instrumentid=" + instrumentid + "&feeder=" + feeder + "&mode=graph";
            }
         },

        tickPositioner : function()  {             
            var first = this.min,
                last = this.max,
                tickInterval = (last - first) / 6,
                newTicks = [Math.floor(first)];

            while (first < last) {
                first += tickInterval;
                newTicks.push(Math.floor(first));
            }

            newTicks.info = this.tickPositions.info;
            return newTicks;                    
        },
        
        initYAxis: function (session) {
            

            let isCompareMode = this.isCompareMode(),
                isVolumeVisible = this.isVolumeVisible(),                
                startOnTick = true,
                endOnTick = true,                
                tickPositioner = undefined,
                tickLength = 4,
                gridLineWidth = undefined;
                

            if (Mode == 'articleComparison') {
                startOnTick = false;
                endOnTick = false;
                tickPositioner = this.tickPositioner;
                gridLineWidth = 0;
                tickLength = 0;
            }

            this.yAxisOptions = [{
                    id: 'valueGraph',                                       
                    labels: {
                        format: '{value}',
                        align: 'right',
                        x: -2,
                        formatter: function() {
                            if (isCompareMode) {
                              return '';
                            } else {
                              return this.value;
                            }
                        }, 
                    },
                    height:  isCompareMode || !isVolumeVisible ? '100%' : '70%', 
                    offset: 1,
                    opposite: false, 
                    crosshair: {
                        snap: false,
                        dashStyle: 'Dash',
                        width: 1,                        
                    },                    
                    endOnTick: endOnTick,
                    showLastLabel: true,                    
                    tickLength: tickLength,
                    tickPosition: 'inside',                                         
                    tickPositioner: tickPositioner,
                    gridLineWidth: gridLineWidth,

                }, {
                    id: 'compare',                   
                    labels: {
                        formatter: function () {
                            let value = this.value,
                                series = this.axis.chart.series[0],
                                val;

                            if (globesChart.isCompareMode()) {
                                return value + '%';
                            } else {
                                let compareValue = series.options.baseRate != undefined ? series.options.baseRate : series.compareValue;
                                val = (value / compareValue) * 100;
                                //console.log(series.compareValue, value, val);  
                                return Highcharts.numberFormat(Highcharts.correctFloat(100 - val) * -1, 1, '.', ',') + '%';
                            }
                        },
                    },
                    height: isCompareMode || !isVolumeVisible  ? '100%' : '70%',   
                    offset: 1,
                    opposite: Mode == 'articleComparison' ? false : true,
                    min: 0,
                    linkedTo: 0,
                    startOnTick: false,
                    endOnTick: endOnTick,
                    showLastLabel: true,
                    tickLength: tickLength,
                    tickPosition: isCompareMode ? 'inside' : 'outside',
                    tickPositioner: tickPositioner,
                    
                }, {
                    id: 'volumeGraph',
                    top: isCompareMode  || !isVolumeVisible  ? '0%' : '80%',
                    height: isCompareMode || !isVolumeVisible  ? '0%' : '20%',
                    offset: 1,
                    opposite: false,
                    endOnTick: true,
                    showLastLabel: true,
                    crosshair: {
                        snap: false,
                        dashStyle: 'Dash',
                        width: 1,
                    },
                    tickPixelInterval: 10,
                    tickLength: 4,
                    tickPosition: 'inside',  
                    visible: isVolumeVisible

                }
            ];

            //add extra indicators axis
            if (session != null) {
                let sessionYAxis = session.yAxisOptions;
                if (sessionYAxis == undefined)
                    return;

                sessionYAxis.forEach((item, index) => {
                    let yAxis = this.yAxisOptions.find((y) => { return y.id == item.id })
                    if (yAxis != undefined) {
                        yAxis.height = item.height;
                        yAxis.top = item.top;
                    } else {
                        this.yAxisOptions.push(item);
                    }
                });
            }
        },
        
        
        initFirstTime: function (pInstParam) {
            
            let me = this;                

            me.chartHeight= '';            
            me.currentInstrument = undefined;
            me.chartType = 'line';
            me.defaultDownload = 'img';
            
            me.indicators = [];   
            me.indicators = [];   
            me.indicatorsParams = [];
            me.isInputClick= false;
            me.isResolutionClick = false;
            me.isAddInstrumentClick = false;
            me.isRangeSelectorClick = false;  
            me.navigatorSeriesData= [];
            me.period = '1d';
            me.prevExtremes = undefined;
            me.selResolution = undefined;
            me.symbols = [];
            me.seriesOptions = [];
                
            me.rangeSelector = undefined;
            me.yAxisOptions = [];

            me.unselectCompareButton();            
            me.unSelectRangeButton();
            me.unSelectResolutionButton();

            
            $(".indicatorsAndCompare .indicators").removeClass("selected");
            $(".graphFrame").removeClass("dark");
            Highcharts.setOptions(Highcharts.themeLight);
            me.changeGraphTypeButton('line');


            let graphTypeId = parseInt($("#hidGraphTypeId").val());
            let iGraphTypeId = typeof (graphTypeId) != undefined ? parseInt(graphTypeId) : 0;
            let isIndexBasic = $("#indexBasic").val() == "2";//מדדים לא רציפים
            if (me.arrNoDayTypes.indexOf(iGraphTypeId) > -1 || isIndexBasic) {
                me.disabledRangeDay();               
            }
            if (typeof isDayCloseDataOnly != 'undefined' && isDayCloseDataOnly) {
                if (!me.isDayRangeDisabled) {
                    me.disabledRangeDay();
                }
                me.disabledRangeWeek(); 
                
            }
            

            let period = me.getPeriod(),
                top = '',
                graphType = 'line',
                now = new Date(),
                end = now.getTime(),
                start = 0,
                symbol = $("#hidGraphSymbol").val(),
                instId = Array.isArray(instrumentid) && instrumentid.length > 0 ? (instrumentid[0] + "|" + feeder[0] + "|" + symbol) : '';


            if (Mode == 'articleComparison') {
                start = graphStartTime;
                end = graphEndTime;
                me.symbols = comparisonSymbols.map(x => x);                
                me.refreshAllData('', '', '', start, end, 'initFirstTime');
                

            } else {

                me.rangeSelectorSet(me.defRangeSelector);
                me.dataGroupingObj = me.getDataGroupingObject_ByRangeSelector(me.rangeSelector.type, me.rangeSelector.count);
                me.selectResolutionButton(me.dataGroupingObj);

                start = Math.round(me.calcRangeStartCalc(now, me.rangeSelector.type, me.rangeSelector.count).getTime())


                if (me.mode.useComparisonSymbols && typeof (comparisonSymbols) != 'undefined' && comparisonSymbols.length > 0) {
                    me.symbols = comparisonSymbols.map(x => x);

                } else {
                    if (pInstParam != undefined) {
                        me.symbols.push(pInstParam);
                    }
                    else if (instId != '') {
                        me.symbols.push(instId);
                    }
                }
                //me.updateState({
                //    symbols: me.symbols,
                //    rangeSelector: me.rangeSelector,
                //    dataGroupingObj: me.dataGroupingObj
                //});


                me.refreshAllData(me.dataGroupingObj, top, period, start, end, 'initFirstTime');
            }
            
            
        },

        legend: function(sId, sName, sType, syAxis, sColor, sIsFirst, sSeriesLen) {
            
            return {
                id: sId,
                name: sName,
                type: sType,
                yAxis: syAxis,
                color: sColor,
                isFirst: sIsFirst,
                gc: this,
                seriesLen: sSeriesLen,
                build: function() {
                    let textClass = this.type != 'line' && this.type != 'candlestick' ? 'en' : '';
                    let maxLen = this.gc.Mode == 'small' ? 3 : 4;
                    let usedName =  this.seriesLen > maxLen && this.name.length > 10 ? this.name.substring(0, 6) + '...' : this.name;
                    return '<div class="legend" data-type="' + this.type + '" data-id="' + this.id + '" title="'+ this.name + '"><span class="circule" style="background-Color:' + this.color + '"></span><span class="' + textClass + '">' + usedName + '</span>' + (this.isFirst ? '' : '<span class="x">x</span>' ) + '</div>';
                }
            }
            
        },

        legendAdd: function(id, name, type, yAxis, color, seriesLen) {
            let gc = this,
                isFirst = this.legends.length == 0,
                newLegend = this.legend(id, name, type, yAxis, color, isFirst, seriesLen),
                html = newLegend.build();

            this.legends.push(newLegend);            
            $("#legendSection").append(html);
            
        },

        legendCustomItemClick : function(e) {

            e.stopPropagation();
            let legendId = $(this).attr("data-id");  

            let filterdCustomLegend = globesChart.legends.filter((item) => item.id == legendId);
            if (filterdCustomLegend.length == 0)
                return;

            
            let obj = filterdCustomLegend[0],
                me = obj.gc,
                isCompareMode = me.isCompareMode(),
                seriesType = obj.type,
                y_axis = obj.yAxis;              

            if (obj && legendId != me.symbols[0] && legendId != 'main') {
                
                //indicators
                if (seriesType != 'line' && seriesType != 'candlestick') {
                    
                    me.removeIndicatorFromDDL(seriesType);                    
                    me.removeSeriesFromChartById(legendId);
                    me.options.series = me.seriesOptions;

                    if (seriesType == 'column') {
                        let volumeYAxis = me.yAxis.options.find((y) => { y.id == 'volumeGraph' })
                        if (volumeYAxis != undefined) {
                            //in future : allow to remove the volume graph
                        }
                    }
                    else if (seriesType != 'bb' && seriesType != 'sma') {
                        me.yAxis_remove(y_axis);
                    }

                    let seriesIndicators = me.getIndicatorsSeriesParams();
                    me.updateState({
                        indicators: me.indicators,
                        indicatorsParams: seriesIndicators,
                        yAxisOptions: me.yAxisOptions,
                        //seriesOptions: me.seriesOptions,
                        chartHeight: me.chartHeight,
                    });
                    
                    globesChart.unselectIndicatorsButton();

                    if (seriesIndicators.length == 0) {
                        chart.update({
                            tooltip: {
                                shared: true,
                                split: false
                            }
                        });
                    }


                    
                    

                }
                //(compare)
                else {  
                                        
                    let instId = legendId;                                            
                    me.removeInstrumentFromSymbols(instId);
                    me.removeSeriesFromChartById(legendId);
                    me.removeInstrumentFromOutsideTable(legendId);
                    me.options.series = me.seriesOptions; 

                    //--keep session updated: if there is arrComparison then we have to remove the inst from it
                    //if (Mode == 'comparison') {
                    if(me.mode.saveState) {
                        let session = me.localSessionRead(),
                            arrComparison = session != undefined ? session.arrComparison : undefined,
                            instrumentId = instId.split('|')[0];

                        if (Array.isArray(arrComparison)) {
                            let itemIndex = arrComparison.findIndex((element) => { return element.id == instrumentId })
                            if (itemIndex > -1) {
                                arrComparison.splice(itemIndex, 1);
                                me.updateState({
                                    arrComparison: arrComparison
                                });
                            }
                        }
                    }
                    //---

                    me.updateState({
                        symbols: me.symbols,
                    });
                }

                //if indicator : remove indicator from selected list                
                me.legendBuildAll();

                //return to base graph
                if (isCompareMode && me.symbols.length == 1) { 
                    
                    me.refreshAllData(me.dataGroupingObj, "", me.getPeriod(), chart.xAxis[0].min, chart.xAxis[0].max, "legendCustomItemClick");
                }               
            }
        },

        legendBuildAll: function() {
            let gc = this;
            $("#legendSection").html('');
            gc.legends = [];

            let seriesLength = chart.series.filter((item) => item.options.showInLegend == true).length;

            $.each(chart.series, function(index, item) {                
                if (item.options.id != 'highcharts-navigator-series' && item.options.showInLegend == true && item.options.visible != false) {                    
                    gc.legendAdd( item.options.id, item.name, item.options.type , item.options.yAxis ,item.options.color, seriesLength); 
                }
            });  

            $("#legendSection .legend").on("click", gc.legendCustomItemClick)
        },

        localSessionSetValue: function (storageName, newProps) {
            let storageObj = JSON.parse(localStorage.getItem(storageName));
            if (storageObj == undefined) {
                let storageObj = {}
            }
            storageObj = {
                ...storageObj,
                ...newProps
            }

            localStorage.setItem(storageName, JSON.stringify(storageObj));            
        },
        
        localSessionSetData: function () {
            try {
                let style = $(".graphFrame").hasClass('dark') ? 'dark' : 'light';
                let chartIndicatorsParams = this.getIndicatorsSeriesParams();
                let dg = chart.xAxis[0].options.dataGrouping;
                let dgUnit = dg !== undefined ? chart.series[0].options.dataGrouping.units[0] : undefined;
                let data = chart.series[0].options.data;
                let dataMin = data != undefined ? data[0][0] : undefined;
                let dataMax = data != undefined ? data[data.length - 1][0] : undefined;
                let isFundComparison = location.href.indexOf('funds') > 0;
                let instType = this.currentInstrument != undefined ? this.currentInstrument.instrumentType : (isFundComparison ? 'fund' : '');
                // let rangeSelectorIndex = this.rangeSelectorIndexGet();
                localStorage.setItem("state", JSON.stringify({

                    chartHeight: this.chartHeight,
                    type: chart.series[0].type,
                    //symbols:            this.symbols,
                    dataGrouingUnit: dgUnit,
                    rangeSelector: this.rangeSelector,
                    //resolution:         $(".resolutionGroup .resolution").index($(".selected")),                   
                    min: chart.xAxis[0].min,
                    max: chart.xAxis[0].max,
                    dataMin: dataMin,
                    dataMax: dataMax,
                    theme: style,
                    indicators: this.indicators,
                    indicatorsParams: chartIndicatorsParams,
                    prevExtremes: this.prevExtremes,
                    currentInstrumentType: instType,
                    selResolution: this.selResolution


                }));

                if (Mode == 'comparison') {
                    this.updateState({
                        tab: 'comapre',
                        symbols: this.symbols,
                        type: 'line'
                    });
                }
            } catch (e) {  }
        },

        localSessionClear: () => {
            localStorage.removeItem("state");            
        },

        localSessionRead: () => {
            let session = JSON.parse(localStorage.getItem("state"));            
            return session;
        },

        navigatorOptions: function() {
            //if (Mode && Mode != '')
            if (this.mode.isNavigator == false)
                return {
                    enabled: false,
                    series: {
                        data: this.navigatorSeriesData,                       
                    },
                }
            else
                return {
                    adaptToUpdatedData: false,
                    series: {
                        data: this.navigatorSeriesData,                       
                    },
                    xAxis: {
                        events: {
                            afterSetExtremes: this.afterSetExtremes,
                        },
                    },
                    yAxis: {
                        reversed: false
                    }
                }
        },

        prepedData: function( arr, instrumentType){
              if(this.getTypeSession() == 'line' && instrumentType != 'currency'){
                  return arr.map(function(point){
                      return [point[0],point[4]];
                  });
              } else {                     
                  return arr;
              }
        },
              
        tooltipSeriesNameConverter: function(series) {
            if (series.type == 'line' || series.type == 'candlestick')
                return series.name + '-' + 'שער';
            return series.name;
        },

       
        
        timeToDate: (time) =>{
            let d = new Date(time)
            let m = d.getMonth() + 1;
            let day = d.getDate();

            m = m < 10 ? '0' + m : m;            
            day = day < 10 ? '0' + day : day;

            return  d.getFullYear()  + '-' + m + '-' + day;
        },

        today: () => {
            let now = new Date();
            return  new Date(now.getFullYear(), now.getMonth(), now.getDate());
        },

        prevDay: (time) => {
            let prevDate = new Date(time);
            return new Date(prevDate.getFullYear(), prevDate.getMonth(), prevDate.getDate());
        },


        
        refreshAllData: function ( dataGroupingObj, sTop, currPeriod, start, end, caller) {
            let me = this,
                firstInstrumentName = '',
                firstInstrumentType = '',
                volume = [],
                yatzig = [],
                isCompare = me.isCompareMode(),
                unit = me.selResolution == undefined ? '' : me.selResolution.res,
                count = me.selResolution == undefined ? '' : me.selResolution.count,
                resolutionParams = me.selResolution == undefined ? '' : (unit === 'minute' ? count : unit.substring(0, 1)),
                chartType = me.chartType ,
                allData = undefined,
                regex1 = RegExp('(restoreSession|addInstrumentToComparison|initFirstTime|changeTheme|legendCustomItemClick)'),
                isToCreateNewChart = regex1.test(caller);
                
               
            if (Mode == 'articleComparison') {
                chartType =   me.symbols.length > 1 ? 'line' : 'area';
                currPeriod = '';
                top = '';
                resolutionParams = ((end - start)/(1000*60*60*24)) < 2 ? 'day' : '';
                sTop = '';
                dataGroupingObj = me.getDataGrouping();
            }
            
            

            me.seriesOptions = [];

            $.each(me.symbols, function (i, param) {
                    let arrParam = param.split('|'),
                        instId = arrParam[0],
                        feeder = arrParam[1],
                        symbol = arrParam[2],
                        isFirst = Mode != 'articleComparison' && me.navigatorSeriesData.length == 0 && i==0, 
                        paramsUrl = me.getDataUrlParams(instId, feeder, symbol, currPeriod, isFirst, start, end, sTop, resolutionParams);

                    $.ajax({
                        method: 'POST',
                        url: paramsUrl.url ,
                        data: paramsUrl.data,
                        dataType: 'text'
                    })
                        .fail(function () {
                            //  debugger
                            console.log(arguments);
                        })
                        .done(function (info) {
                           // debugger
                             info = eval("(" + info + ")");

                             let isToShowBase = currPeriod == 'day' && info.data != undefined && info.data.length > 0 && info.data[0].length >= 7 && !isCompare,
                                 arrBaseRate = !isToShowBase ? [] : info.data.filter(function (arr, index) { return arr[6] == 'B' }),
                                 data = !isToShowBase ? info.data : info.data.filter(function (arr, index) { return arr[6] != 'B' }),
                                 allData = info.allData != undefined ? info.allData :  (me.navigatorSeriesData.length > 0 ?  me.navigatorSeriesData : info.data) ,
                                 instId = info.instid,
                                 instrumentType = info.instrumenttype,
                                 instrumentTypeId = parseInt(info.typeid),
                                 mapedData = me.prepedData(data, instrumentType),
                                 tooltipOptions = me.setTooltipFormater(instrumentType, true, chartType),
                                 periodType = info.type;

                            

                            if (currPeriod == 'day' && instrumentType != 'currency' && arrBaseRate.length == 0 && info.baseRate != undefined) {
                                arrBaseRate[0] = [];
                                arrBaseRate[0][1] = parseFloat(info.baseRate);
                            } 

                            if (Mode == 'articleComparison' && info.baseRate != undefined) {
                                var prevTime = mapedData[0][0] - (12 * 60 * 60 * 1000);
                                mapedData.unshift([ prevTime, parseFloat(info.baseRate) ]);
                            }
                            

                            me.seriesOptions.push({
                                data: (isCompare || chartType == 'line' ? mapedData : data),
                                type: ((isCompare && Mode != 'articleComparison') || chartType == 'line' || instrumentType == 'currency' ? 'line' : chartType /* 'candlestick' */ ),
                                id: (isCompare ? param : 'main'),
                                name: info.name,
                                yAxis: 0,
                                showInLegend: true,
                                compare: (isCompare ? 'percent' : 'none'),
                                compareStart: false,
                                tooltip: tooltipOptions,
                                zIndex: 2,
                                baseRate: arrBaseRate.length > 0 ? arrBaseRate[0][1] : undefined

                            });

                            
                            //first series
                            if (instId == me.symbols[0]) {

                                me.currentInstrument = {
                                    mapedData: mapedData,
                                    orgData: data,
                                    instrumentType: instrumentType,
                                    instrumentTypeId: instrumentTypeId,
                                    baseArr: arrBaseRate
                                };
                                firstInstrumentName = info.name;

                                if (me.mode.isNavigator && me.navigatorSeriesData.length == 0) //in restoreSession
                                    me.navigatorSeriesData = allData;

                                //in indicators add yatzig or volume
                                if (!isCompare && data.length > 0) {
                                    if (instrumentType == 'currency' && instrumentTypeId != 46) {//yatzig
                                        if (instrumentTypeId == 20 && (periodType == 'day' || periodType == 'week')) {
                                            for (let i = 0; i < data.length; i++) {
                                                let time = data[i][0];
                                                let val = parseFloat(data[i][2]);
                                                if (!isNaN(val)) {
                                                    yatzig.push([time, val]);
                                                }
                                            }                                            
                                        }
                                        if (periodType == 'day') {
                                            yatzig.push([end, parseFloat(data[0][2])]);
                                        }
                                        
                                    } else {  //volume                                        
                                        volume = me.fillVolumeData(data);
                                    }
                                }
                            }

                            //finish all                           
                            if (me.seriesOptions.length == me.symbols.length) {

                                let firstSeriesWithData = me.seriesOptions[0];

                                if (isCompare) { //in compare : sort the seriesOptions in the order the symbols entered the array
                                    //colors
                                    me.seriesOptions.sort((a, b) => {
                                        let subset = me.symbols.indexOf(a.id) - me.symbols.indexOf(b.id);
                                        if (subset < 0) return -1;
                                        if (subset > 0) return 1;
                                        return 0
                                    });
                                    $.each(me.seriesOptions, function (i, series) {
                                        series.color = Highcharts.defaultOptions.colors[i];
                                    });

                                    //find the oldest data to show in the xAxis scale - for etf/fund home page                                  
                                    if (instrumentid[0] == 0) {
                                        let sortedSeries = me.seriesOptions.map((item) => {
                                            if (item.data.length > 0)
                                                return item
                                        });
                                        sortedSeries.sort((a, b) => {
                                            let subset = a.data[0][0] - b.data[0][0];
                                            if (subset < 0) return -1;
                                            if (subset > 0) return 1;
                                            return 0;
                                        });
                                        firstSeriesWithData = sortedSeries[0];
                                    }

                                    if (me.seriesOptions[0].type == 'area') {
                                        let isDownColor = mapedData.length > 0 && mapedData[mapedData.length - 1][1] - mapedData[0][1] < 0;
                                        if (isDownColor) {
                                            me.seriesOptions[0].color = Highcharts.getOptions().downColors[0];
                                            me.seriesOptions[0].fillColor = Highcharts.getOptions().downColors[1];
                                           // me.seriesOptions[0].fillOpacity = 0.2
                                        }
                                    }


                                } else { //not compare



                                    //colors
                                    if (me.chartType == 'line') {
                                        me.seriesOptions[0].color = Highcharts.defaultOptions.colors[0];
                                    }
                                    //build yatzig or volume series
                                    if (instrumentType == 'currency') {
                                        if (yatzig.length > 0) {                                            
                                            me.seriesOptions.push({
                                                type: 'line',
                                                name: instrumentName + '-יציג',
                                                data: yatzig,
                                                id: 'yatzig',
                                                yAxis: 0,
                                                decimals: 4,
                                                marker: {
                                                    enabled: false
                                                },
                                                showInLegend: (periodType == 'week' ? true : false),
                                                compare: 'none',
                                               // tooltip: tooltipOptions,
                                                tooltip: {
                                                    ...tooltipOptions,
                                                    enabled: true
                                                },
                                                color: 'red',
                                                visible: (isCompare ? false : true),
                                                zIndex: 1,
                                            });
                                        }
                                    } else {
                                        if (me.isVolumeVisible()) {
                                            me.seriesOptions.push({
                                                type: 'column',
                                                name: instrumentName + '-נפח מסחר',
                                                data: volume,
                                                id: 'volume',
                                                yAxis: 2,
                                                decimals: 4,
                                                marker: {
                                                    enabled: false
                                                },
                                                color: Highcharts.defaultOptions.colors[0],
                                                showInLegend: false,
                                                compare: 'none',
                                                visible: (isCompare ? false : true),

                                            });
                                        }
                                    }

                                    if (me.mode.isIndicators && !isCompare && me.indicatorsParams.length > 0) {
                                        me.indicatorsParams.forEach(function (item, index) {
                                            let newItem = JSON.parse(JSON.stringify(item));

                                            newItem.tooltip = globesChart.setTooltipFormater(me.currentInstrument.instrumentType, true, newItem.type.toLowerCase())
                                            me.seriesOptions.push(newItem);
                                        });
                                    }
                                }//end not compare
                                    

                                let firstSeries = firstSeriesWithData, //instrumentid[0] != 0 ? me.seriesOptions[0] : oldestSeries,
                                    firstData = firstSeries != undefined ? firstSeries.data : [],
                                    dataMin = firstData.length > 0 ? firstData[0][0] : null,
                                    dataMax = firstData.length > 0 ? firstData[firstData.length - 1][0] : null,
                                    xMin = start != '' ? Math.max(dataMin, start) : dataMin,
                                    xMax = end != '' ? (dataMax != null ? Math.min(dataMax, end) : end) : dataMax,
                                    xMin_indexInData = firstData.findIndex(item => item[0] == xMin);
                                    //compareVal = xMin_indexInData > 0 ? firstData[xMin_indexInData-1][2]
                                    


                                if (currPeriod == 'day') {
                                    let dayExtremes = me.findDayExtremes();
                                    xMin = dayExtremes.min;
                                    xMax = dayExtremes.max;
                                }



                                if (chartType == 'line' && me.currentInstrument != undefined && me.currentInstrument.baseArr.length > 0 ) {

                                    let baseArr = me.currentInstrument.baseArr,
                                        arrBaseLine = [{
                                            x: xMin,
                                            y: baseArr[0][1],
                                            dataLabels: {
                                                enabled: true,
                                                format: '{series.name}',
                                                style: {
                                                    textOutline: '',
                                                    fontWeight: '',
                                                    fontSize: '10px',
                                                },
                                                y: 20,
                                            },
                                        },
                                        [xMax, baseArr[0][1]]
                                        ];

                                    me.seriesOptions.push({
                                        data: arrBaseLine,
                                        type: 'line',
                                        id: 'baseRate',
                                        name: baseArr[0][1] + ' :בסיס',
                                        yAxis: 0,
                                        showInLegend: false,
                                        color: 'red',
                                        dataGrouping: {
                                            enabled: false
                                        },
                                        tooltip: {
                                            enabled: false
                                        },
                                        enableMouseTracking: false,
                                        compare: 'none',
                                        zIndex: 1,
                                        visible: !isCompare
                                    });
                                }



                                me.options = me.setOptions();  
                                if (caller != 'restoreSession' && caller != 'changeTheme') {
                                    me.initYAxis();
                                }
                                me.options.yAxis = me.yAxisOptions;
                                me.options.series = me.seriesOptions;
                                me.options.xAxis.ordinal = me.getOrdinal(sTop);
                                if (Mode == 'articleComparison') {
                                    me.options.xAxis.dateTimeLabelFormats = {                                        
                                        day: ['%d/%m/%y'],                                        
                                        week: ['%d/%m/%y'],
                                        month: ['%b %Y'],
                                        year: ['%Y']
                                    };

                                    
                                }

                                //chart = me.createChart(me.options);

                                //creating chart
                                if (chart == undefined || isCompare || isToCreateNewChart) {
                                    chart = me.createChart(me.options);
                                } else {
                                    chart.update({
                                        series: me.options.series,
                                        yAxis: me.options.yAxisOptions,
                                        xAxis: {
                                            ordinal: me.options.xAxis.ordinal,
                                        }
                                    }, false, true);

                                    //if (Mode == '' && !isCompare && me.chartHeight != '') {
                                    //chart.setSize(undefined, me.chartHeight);
                                    //}
                                }


                                let xData = firstSeries != undefined ? firstSeries.data : undefined;
                                if (xData != undefined && xData.length > 0) {
                                    me.prevExtremes = {
                                        dataMin: xData[0][0],
                                        dataMax: xData[xData.length - 1][0],
                                        period: sTop != '' ? '' : currPeriod,
                                        time: (new Date()).getTime()
                                    };

                                } else {
                                    me.prevExtremes = undefined;
                                }
                                me.legendBuildAll();


                                let isTop = sTop != '' ? true : false;

                                setTimeout(() => {
                                    chart.xAxis[0].setDataGrouping(dataGroupingObj, isTop);

                                    let points = chart.xAxis[0].series[0].points;
                                    if (isTop) {
                                        if (points.length > me.maxPoints)
                                            xMin = points[points.length - me.maxPoints].x;
                                    } else {
                                        if (isCompare) {
                                            xMin = points != undefined ? points[0].x : xMin;
                                        }
                                    }

                                    chart.xAxis[0].setExtremes(xMin, xMax);

                                    chart.hideLoading();

                                    
                                    me.dataGroupingObj = dataGroupingObj;
                                    me.selectResolutionButton(dataGroupingObj);
                                    


                                    me.updateInputs(xMin, xMax);

                                    let currentInstrumentType = me.currentInstrument != undefined ? me.currentInstrument.instrumentType : '',
                                        currentInstrumentTypeId = me.currentInstrument != undefined ? me.currentInstrument.instrumentTypeId : 0;

                                    if (me.mode.saveState) {
                                        if (me.localSessionRead() == undefined) {
                                            me.localSessionSetData();
                                        } else {
                                            me.updateState({
                                                type: chart.series[0].type,
                                                dataGrouping: dataGroupingObj,
                                                min: xMin,
                                                max: xMax,
                                                dataMin: dataMin,
                                                dataMax: dataMax,
                                                prevExtremes: me.prevExtremes,
                                                currentInstrumentType: currentInstrumentType,
                                                currentInstrumentTypeId: currentInstrumentTypeId,
                                                rangeSelector: me.rangeSelector,
                                                selResolution: me.selResolution,
                                            });
                                        }
                                    }

                                }, 1);


                                
                            }
                        });
                });                
            
        },

        removeInstrumentFromSymbols: function (instParam) {
            let index = this.symbols.indexOf(instParam)
            if (index > -1)
                this.symbols.splice(index, 1);
            
        },
               

        removeSeriesFromChartById: function (seriesId) { 
            

            if (seriesId === 'volume') {
                let series = chart.get(seriesId);
                series.hide()
            } else {
                let seriesIndex = this.seriesOptions.findIndex((m) => m.id == seriesId);
                if (seriesIndex > -1) 
                    this.seriesOptions.splice(seriesIndex, 1);                

                let indicatorIndex = this.indicatorsParams.findIndex((m) => m.id == seriesId);
                if (indicatorIndex > -1)
                    this.indicatorsParams.splice(indicatorIndex, 1);

                let series = chart.get(seriesId);
                if (series != undefined)
                    series.remove()
            }
        },
        
        removePerviousIndicatorsSeries: function (type) {
             let arrFilteredSeriesToRemove = chart.series.filter((s) => s.userOptions.type == type),
                 yAxisId = '',
                 me = this;


            if (arrFilteredSeriesToRemove.length > 0) {
                arrFilteredSeriesToRemove.forEach(function (series, index) {
                    let id = series.userOptions.id;
                    let yAxis = series.userOptions.yAxis;
                
                    chart.get(id).remove();

                    let pos = me.seriesOptions.findIndex((item) => { return item.id == id });
                    if (pos > 0) {
                        me.seriesOptions.splice(pos, 1);
                    }
                    pos = me.indicatorsParams.findIndex((item) => { return item.id == id });
                    if (pos > -1) {
                        me.indicatorsParams.splice(pos, 1);
                    }


                    if (type != 'bb' && type != 'sma') {
                        yAxisId = yAxis;
                    }
                
                });
             }
            return yAxisId;
         },
        
        removeIndicatorFromDDL: function(indicatorType) {            
            let indicatorIndex = globesChart.indicators.indexOf(indicatorType);
            if (indicatorIndex > -1) {
                globesChart.indicators.splice(indicatorIndex, 1);            
                $("#selIndicatorWraper ul li[data-value='" + indicatorType + "']").removeClass('selected')
            }                
        },

        //activate from outside :highChart_graph_comparison_search.js
        removeInstrumentFromOutside: function (instId) {
            this.removeInstrumentFromSymbols(instId);            
            this.removeSeriesFromChartById(instId);
            this.legendBuildAll();
            this.options.series = this.seriesOptions; 
            this.updateState({
                symbols: this.symbols,
            });
        },

        removeInstrumentFromOutsideTable: function (instId) {
            let $outsideChkbox = $("#tblIndexInstruments tr td.tdInstrumentData[data-id='" + instId + "']")
            if ($outsideChkbox.length > 0) {
                $outsideChkbox.find( "input:checked" ).prop('checked', false);
            }
        },

        rangeSelectorIndexGet: function(session){
            let range = '';
            if (session && session.rangeSelector) {
                range = session.rangeSelector.selected;
            }else {
                if (this.rangeSelector != undefined )
                    range = this.rangeSelector.selected;
                else
                    range = this.defRangeSelector;
            }

            return range;
        },

        rangeSelectorGetAll: function () {
            return $(".rangeSelectorLine .customRangeSelectorButtons .rangeSelector:visible");
        },

        rangeSelectorSet: function (index) {
            let obj = this.rangeSelectorGetAll().eq(index)
            $(obj).addClass("selected")
            this.rangeSelector = {
                type: $(obj).attr("data-type"),
                count: parseInt($(obj).attr("data-count")),
                selected: index
            }           
        },

        restoreSession: function (session) {

          //  debugger
            
            let symbol = $("#hidGraphSymbol").val(),
                instrumentParam = this.mode.useComparisonSymbols ? comparisonSymbols : [instrumentid + '|' + feeder + '|' + symbol],                
                me = this;

            let graphTypeId = $("#hidGraphTypeId").val();
            let iGraphTypeId = typeof (graphTypeId) != undefined ? parseInt(graphTypeId) : 0;
            let isIndexBasic = $("#indexBasic").val() == "2";
            if (me.arrNoDayTypes.indexOf(iGraphTypeId) > -1 || isIndexBasic)
                me.disabledRangeDay();
            if (typeof isDayCloseDataOnly != 'undefined' && isDayCloseDataOnly)  {
                if (!me.isDayRangeDisabled) {
                    me.disabledRangeDay();
                }
                me.disabledRangeWeek();
            }



            if (Mode == 'comparison') { 
                if (session.tab != 'compare') {
                    globesChart.updateState({
                        tab: 'compare',
                        type: 'line',
                        symbols: instrumentParam
                    });

                    session.tab = 'compare';
                    session.type = 'line';
                    session.symbols = instrumentParam;
                }                
            }


            try {   
                
                me.theme = session.theme;
                me.indicators = [];                   
                me.indicatorsParams = [];
                me.seriesOptions = [];
                me.prevExtremes = session.prevExtremes;
                me.selResolution = session.selResolution;
                me.rangeSelector = session.rangeSelector;
                me.symbols = instrumentParam;
                me.initYAxis();
                me.tab = session.tab;
                me.defaultDownload = session.defaultDownload;
                me.dataGroupingObj = session.dataGrouping

                me.selectResolutionButton(me.dataGroupingObj, session.resolution);
                me.setTheme(session);

                //set range button
                if (me.rangeSelector != undefined) {                    
                    let rangeButtonIndex = parseInt(me.rangeSelector.selected);
                    let $selectedRangeButton = me.rangeSelectorGetAll().eq(rangeButtonIndex);
                    const selectedRangeeButtonType = $selectedRangeButton.attr('data-type');

                    if (me.rangeSelector.type != selectedRangeeButtonType) {
                        this.initFirstTime();
                        return;
                    }
                    
                    $selectedRangeButton.addClass('selected')
                } else {
                    $(".customRangeSelectorButtons .rangeSelector[data-type='custom']").addClass('selected');
                }

                me.chartType = session.type
                if (session.type != 'line') {//just change the selected button
                    this.changeGraphTypeButton(session.type);
                } else {
                    this.changeGraphTypeButton('line')
                }

                

                let period = this.getPeriod(session),
                    dataMin = session.dataMin,
                    dataMax = me.rangeSelector == undefined ? session.dataMax : (new Date()).getTime(),
                    axisMin = session.min,
                    axisMax = me.rangeSelector == undefined ? session.max : (new Date()).getTime(),
                    graphType = session.type,
                    sessionInstrumentType = session.currentInstrumentType, 
                    sessionInstrumentTypeId = session.currentInstrumentTypeId,
                    top = me.selResolution != undefined ? me.maxPoints : '',
                    unit = me.selResolution != undefined ? me.selResolution.res : '',
                    count = me.selResolution != undefined ? me.selResolution.count : '',
                    resolutionParams = me.selResolution == undefined ? '' : (unit === 'minute' ? count : unit.substring(0, 1)),
                    isCompare = me.isCompareMode(),
                    firstInstrumentName = '',
                    volume = [],
                    yatzig = [];

                if ( sessionInstrumentTypeId != iGraphTypeId) {
                    session.indicators = undefined;
                    session.indicatorsParams = undefined;
                    session.yAxisOptions = undefined;
                    session.chartHeight = '';
                }


                //$('.indicatorsAndCompare .indicators , .indicatorsAndCompare .indicators').removeClass('selected');
                if (me.tab == 'indicators') { 
                    //debugger

                    //if no volume and session indicators include Accumulation Distribution (AD) 
                    //  if (iGraphTypeId > 0 &&  me.arrNoVolumeGraph.indexOf(iGraphTypeId) > -1 &&   session.indicators != undefined &&  session.indicators.indexOf("ad") > -1) {
                    if (session.indicators == undefined) {
                        me.chartHeight = '';
                        me.initYAxis();
                        me.indicators = [];
                        me.indicatorsParams = [];
                    } else {
                        me.chartHeight = session.chartHeight;
                        me.initYAxis(session)
                        me.indicators = session.indicators != undefined ? session.indicators : [];
                        me.indicatorsParams = session.indicatorsParams != undefined ? session.indicatorsParams : [];
                        me.indicatorsParams.forEach(function (series, index) {
                            series.tooltip = me.setTooltipFormater(sessionInstrumentType, true, series.type);
                        });
                    }
                    $(".indicatorsAndCompare .indicators").addClass("selected");

                } else {
                    if (me.tab == 'compare') {//compare
                        let isSymbolExists = session.symbols != undefined && session.symbols.length > 0 && session.symbols[0] == instrumentParam[0];
                        me.symbols = isSymbolExists ? session.symbols : instrumentParam;                          
                        $(".indicatorsAndCompare .compare").addClass("selected");
                        me.chartHeight = '';
                        me.initYAxis();
                    }                    
                }

                                        
                me.refreshAllData(me.dataGroupingObj, top, period, axisMin, axisMax, 'restoreSession');

               
            } catch (e) {
                console.log(e);
                me.initFirstTime();
            }
        },
                
        showMaxSymbolsAlert: function (msg) {    
            
            if (Mode == 'small') {
                alert(msg)            
            }
            if (chart != undefined) {
                globesChart.setDialogPosition("section.maxSymbolsAlert");
                $("section.maxSymbolsAlert .content").html(msg);
                $("section.maxSymbolsAlert").show();

                $("section.maxSymbolsAlert h2 span.close , section.maxSymbolsAlert div span.ok").click(function (e) {
                    e.stopPropagation();
                    $(window).off('scroll')
                    $("section.maxSymbolsAlert").hide();
                    $("#divGraphSearchBox").hide();
                    
                });
            }  
        },
    
        scrollbarOptions: function(){
            //if (Mode && Mode != '')
            if( !this.mode.isNavigator )
                return {
                    enabled: true,
                    height: 0,
                    buttonArrowColor: 'transparent',
                    margin: 0,
                }
            else
                return {
                    enabled: true,
                    liveRedraw: false
                }
        }, 

        setExtremes: function (e) {
            let me = this,
                min = Math.floor(e.min),
                max = Math.floor(e.max),           
                now = new Date(),
                milsecInOneDay = 1000 * 3600 * 24,
                numOfDays = (max - min )/ milsecInOneDay;

            if (e.trigger == 'navigator' && numOfDays < 27)
                return false;
            
        },

        setResolutionButtonColor: (unitName) => {
            $(".resolution").removeClass("selected")
            if (unitName != undefined) {                
                $(".resolution."+ unitName).addClass("selected");
            }
        },

        setDatePickerDefault:  () => {
            $.datepicker.setDefaults({
                dateFormat: 'yy-mm-dd',                
                onSelect: function (dateText) {                    
                    globesChart.isInputClick = true;
                    globesChart.isResolutionClick = false;
                    globesChart.unSelectRangeButton();
                    globesChart.selectRangeCustomButton();
                    chart.xAxis[0].setExtremes($('#txtMinDate').datepicker("getDate").getTime(), $('#txtMaxDate').datepicker("getDate").getTime());
                }
            });

        },

        selectResolutionButton: (dataGroupingObj, index) => {
            let res, resCount;
            if (dataGroupingObj !== undefined && dataGroupingObj != '' && dataGroupingObj.units != undefined) {
                res = dataGroupingObj.units[0][0],
                resCount = dataGroupingObj.units[0][1][0];
            }
            else { //in restore session
                if (!isNaN(index)) {
                    let iIndex = parseInt(index),
                        objRes = $(".resolution").eq(iIndex);
                    res = $(objRes).attr('data-res');
                    resCount = $(objRes).attr('data-count');
                }
            }
            $(".resolution[data-res='" + res + "'][data-count='"+ resCount+"']").addClass("selected");
        },

        selectRangeCustomButton: () => {
            $(".rangeSelector[data-type='custom']").addClass('selected')
        },

        selectTool: function (obj,tool) {
            
            $(obj).parent().find("span").removeClass("selected");
            $(obj).addClass("selected")
            $("#hidSelection").val(tool)
        },

        
        setTheme: (session) => {
            if (session && session.theme == 'dark') {
                Highcharts.setOptions(Highcharts.themeDark);
                $(".graphFrame").addClass("dark");

            } else {
                Highcharts.setOptions(Highcharts.themeLight);
            }
        },

        setTooltipFormater: function(instrumentType, showFullName = false, chartType) {            
            let title = function (series) {
                if (globesChart.isCompareMode() || showFullName || chartType == 'candlestick') {
                    return series.name
                } else {                    
                    return "שער"                    
                }
            };
            let getCompareValue = function (series) {
                return series.options.baseRate != undefined ? series.options.baseRate : series.compareValue;
            };
            let tooltip = undefined;
            switch (instrumentType) {
                case 'currency':
                    tooltip = {
                        pointFormatter: function() {
                            let seriesTitle = title(this.series);
                            let compareValue = getCompareValue(this.series);
                            let change = Highcharts.numberFormat(Highcharts.correctFloat(100 - (this.y / compareValue) * 100) * -1, 2, '.', ',');
                            return '<span style="color:' + this.series.color + '">●</span>' + seriesTitle + ' : <b><span class="tooltipNumBold">' + Highcharts.numberFormat(this.y, 4) + '</span></b><span class="tooltipNum"> (' + change + '%)</span><br/>';
                        },
                    };
                    break;

                case 'optionmaof':
                case 'sma':
                case 'ad':
                case 'atr':
                case 'rsi':
                    tooltip = {
                        pointFormatter: function() {
                            let seriesTitle = title(this.series),
                                compareValue = getCompareValue(this.series);
                            let change = Highcharts.numberFormat(Highcharts.correctFloat(100 - (this.y / compareValue) * 100) * -1, 2, '.', ',');
                            return '<div  class="tooltip"><span style="color:' + this.series.color + ';">●</span><span class="tooltipNum">' + seriesTitle + '</span> : <span class="tooltipNum">(' + change + '%) <b>' + Highcharts.numberFormat(this.y, 2) + '</b></span></div>';
                        },
                    };
                    break;
                case 'bb':
                    tooltip = {
                        pointFormatter: function() {
                            let seriesTitle = title(this.series),
                                compareValue = getCompareValue(this.series);
                            let change = Highcharts.numberFormat(Highcharts.correctFloat(100 - (this.y / compareValue) * 100) * -1, 2, '.', ',');
                            return '<div class="tooltip"><span style="font-weight:bold;color:' + this.series.color + ';">●</span><span class="tooltipNum">' + seriesTitle + '</span> : <br/><span class="tooltipTitle">עליון:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.top, 2) + '</span><br/><span class="tooltipTitle">אמצע:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.middle, 2) + '</span><br/><span class="tooltipTitle">תחתון:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.bottom, 2) + '</span></div>';
                        },
                    };
                    break;
                case 'macd':
                    tooltip = {
                        pointFormatter: function() {
                            let seriesTitle = title(this.series),
                                compareValue = getCompareValue(this.series);
                            let change = Highcharts.numberFormat(Highcharts.correctFloat(100 - (this.y / compareValue) * 100) * -1, 2, '.', ',');
                            return '<div class="tooltip"><span style="font-weight:bold;color:' + this.series.color + '">●</span><span class="tooltipNum">' + seriesTitle + '</span> : <br/><span class="tooltipTitle">ערך:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.MACD, 2) + '</span><br/><span class="tooltipTitle">איתות:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.signal, 2) + '</span><br/><span class="tooltipTitle">הסטוגרמה:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.y, 2) + '</span></div>';
                        },
                    };
                    break;
                default:
                    if (chartType == 'candlestick') {
                        tooltip = {
                            pointFormatter: function() {
                                let seriesTitle = title(this.series),
                                    compareValue = getCompareValue(this.series);
                                let change = Highcharts.numberFormat(Highcharts.correctFloat(100 - (this.close / compareValue) * 100) * -1, 2, '.', ',');
                                return '<div class="tooltip"><span style="color:' + this.series.color + ';">●</span>' + seriesTitle + ': <br/><span class="tooltipTitle">פתיחה:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.open, 2, '.', ',') + '</span><br/><span class="tooltipTitle">גבוה:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.high, 2, '.', ',') + '</span><br/><span class="tooltipTitle">נמוך:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.low, 2, '.', ',') + '</span><br/><span class="tooltipTitle">סגירה:</span><span class="tooltipNum">' + Highcharts.numberFormat(this.close, 2, '.', ',') + '</span><br/><span class="tooltipTitle">שינוי %:</span><span class="tooltipNum"> (' + change + '%)</span></div>';
                            }
                        }
                    } else {
                        tooltip = {
                            pointFormatter: function() {
                                let seriesTitle = title(this.series),
                                    compareValue = getCompareValue(this.series);
                                let change = Highcharts.numberFormat(Highcharts.correctFloat(100 - (this.y / compareValue) * 100) * -1, 2, '.', ',');
                                return '<div class="tooltip" style="height:17px;"><span style="padding:0 0 0 5px;color:' + this.series.color + ';">●</span><span class="tooltipNum">' + seriesTitle + '</span> : <b><span class="tooltipNum">' + Highcharts.numberFormat(this.y, 2) + '</span></b><span class="tooltipNum"> (' + change + '%)</span></div>';
                            },
                        }
                    }
                    break;
            }

           
            let tempDateTimeFormats = {
                millisecond: '%A, %b %e, %H:%M',
                day: '%A, %b %e, %Y',
                week: '%d/%m/%Y',                   
            }

            if (Mode == 'articleComparison' && (typeof isDailyOverView == 'undefined' || !isDailyOverView )) {
                 tempDateTimeFormats = {
                    millisecond: '%A, %b %e, %H:%M',
                    second: '%A, %b %e, %Y',
                    day: '%d/%m/%Y, %H:%M',
                    week: '%d/%m/%Y',
                }
            }

            return tooltip = {
                ...tooltip,
                dateTimeLabelFormats: tempDateTimeFormats
            };
            

        },

        setOptions: function(obj){

            let chartHeight = globesChart.getChartHeight(obj),
                chartHeight2 = screen.height / screen.width,
                chartPanning = globesChart.getPanning(),
                chartNavOptions = globesChart.navigatorOptions(),
                chartScrollOpt = globesChart.scrollbarOptions(),
                isComppareMode = globesChart.isCompareMode(),
                shareTooltip = globesChart.indicators.length == 0,
                spacingBottom = 0,
                marginLeft = undefined,
                spacingTop = 10,
                objTitle = {},
                marginBottom = Mode == 'small' ? 5 : undefined,
                bStyleMode = false,
                isCreditsEnabled = false,
                titleFontSize = this.isMobile() ? "17px" : "18px",
                tooltipFamily = "'OpenSansHebrew', sans-serif";
                

            if (Mode == 'articleComparison') {
                bStyleMode = true;                
                isCreditsEnabled = true;
                marginBottom = 11;
                spacingBottom = 10;
                marginLeft = 3;
                spacingTop = 0;
                objTitle = {
                    text: graphTitle,
                    useHTML: true,
                    margin: 0,
                    style: {
                        fontSize: titleFontSize,
                        fontFamily: "'OpenSansHebrew', sans-serif",
                        fontWeight: "bold",
                        direction: "rtl",
                        textAlign: "center"
                    },
                }
                tooltipFamily = "'OpenSansHebrew', sans-serif";
            }

            return {
                chart: {
                        alignTicks: false,
						borderWidth: 0,
                        borderColor: '#e8eaeb',
                        //borderWidth: 1,
                        height: chartHeight,						
						renderTo: 'container',                        
                        type: 'line',                        
						events: {
                            load: globesChart.chartLoad,   
                            render: globesChart.chartRender,
                        },
                        panning: chartPanning,                        
                        spacingBottom: spacingBottom,                        
                        spacingTop: spacingTop,
                        marginBottom: marginBottom,                         
                        styledMode: bStyleMode,
                },
                credits: {
                    enabled: isCreditsEnabled,
                    text: "גלובס" , 
                    style: {
                        fontFamily: 'OpenSansHebrew, sans-serif',                                      
                        fontWeight: 'normal',
                        fontSize: "12px",
                        direction: 'rtl',
                    },
                    position: {
                        x: -32,
                        y: 0,
                    }
                    
                },                
                annotationsOptions: {
                    enabledButtons: false,
                },        
                time: {
                    //useUTC: true,
                    timezoneOffset: -1 * timeZoneOffset * 60
                },
                title: objTitle,
                navigator: chartNavOptions,
                navigation: {
                    buttonOptions: {
                        enabled: false,
                    },
                    series:  globesChart.navigatorSeriosData,
                },
                
                
                scrollbar: chartScrollOpt,               

                legend: {
                    enabled: false,                    
                },                
                plotOptions: {                     
                    candlestick: {
                        color: '#EA5641',
                        upColor: '#5CAB63',
                        colorIndex: 6,
                        dataLabels: {
                            useHTML: true,
                            format: '\u202B' +  '{point.name}',
                            style: {
                                fontFamily: 'tahoma',                                      
                                direction:'rtl',
                            },
                        },
                        
                    },
                    OHLC: {
                        color: '#EA5641',
                        upColor: '#5CAB63',
                        dataLabels: {
                            useHTML: true,
                            format: '\u202B' +  '{point.name}',
                            style: {
                                fontFamily: 'tahoma',                                      
                                direction:'rtl',
                            },
                        }
                    },
                    line: {
                        showCheckbox: false,
                        dataGrouping: {
                            enabled: true,
                            approximation: 'close',
                            dateTimeLabelFormats: this.dateTimeLabelFormats
                        },
                    },
                    area: {
                        showCheckbox: false,
                        dataGrouping: {
                            enabled: true,
                            approximation: 'close',
                            dateTimeLabelFormats: this.dateTimeLabelFormats
                        },
                    },
                    column: {
                        minPointLength: 1, 
                        pointPadding: 0.2,
                    },
                    macd: {
                        zones: [{
                            value: 0,
                            color: 'green'
                        }, {
                            color: 'red'
                        }]
                    },
                    series: this.plotOptionsSeries
                },

                tooltip: {
                    //pointFormat: pointFormatOption,
                    valueDecimals: 2,
                    useHTML: true,
                    style: {
                        fontSize: '12px',
                        fontFamily: tooltipFamily,
                        direction: 'rtl',
                        textAlign:'right'
                    },
                    shared: shareTooltip,
                    split: !shareTooltip,                     
                    useHTML: true,
                    padding: 10,
                },

                rangeSelector: {                    
                     inputEnabled: false,
                     allButtonsEnabled: false,
                },

                xAxis: {
                    ordinal: true,
                    events: {
                        afterSetExtremes: globesChart.afterSetExtremes,
                        setExtremes: globesChart.setExtremes,
                    },
                    lineWidth: 1,
                    minRange: 3600 * 1000 , // one hour
                    crosshair: {
                        snap: false,
                        dashStyle: 'Dash',
                        width: 1,                        
                    },                    
                    labels: {
                        // step:1,
                        //overflow: false,
                        // padding: 10,
                       // useHTML: true,
                         autoRotation: [-10, -20, -30, -40, -50, -60, -70, -80, -90]
                    },
                    startOnTick: false,
                    tickAmount: 8,
                    

                },

                yAxis: this.yAxisOptions,

                series: this.seriesOptions,

                exporting: {
                    
                    //url: 'http://export.highcharts.com/index-utf8-encode.php',                  
                    allowHTML: true, 
                
                    chartOptions: {
                        chart: {
                            width: 888,
                            height: 500,
                            events: {
                                load: function () {
                                    let objPos = globesChart.creditPosition(this);
                                    let img = this.renderer.image("https://images.globes.co.il/images/portal/graphs/globes.svg", objPos.x , objPos.y , objPos.width, objPos.height)
                                    img.add();                                   
                                },
                            }
                        },
                        legend: {
                            enabled: true,
                            useHTML: true,
                            rtl: true,
                            align: 'center',
                            verticalAlign: 'top',
                            style: {
                                fontFamily: 'tahoma',
                                direction: 'rtl'

                            },
                            floating: true,
                            y: 0,
                            spacingTop: 0,
                            itemMarginTop: 0,
                            itemMarginBottom: 0,
                            margin: 1,
                            //borderColor: globesChart.backgroundColor,
                            symbolRadius: 6,
                            symbolWidth: 10,
                            itemCheckboxStyle: {
                                height: '13px',
                                position: 'absolute',
                                width: '13px'
                            },
                        },
                        xAxis: {
                            labels: {                                                         
                                useHTML: true,
                            },
                        },
                        rangeSelector: {
                            enabled: false,
                            inputEnabled: true,
                        },
                        navigator: {
                            enabled: true
                        },
                        scrollbar: {
                            enabled: false,
                        },
                    }
                }
            }
           
        },

        setDialogPosition: function (obj) {
            let formHeight = $(obj).height(),
                windowHeight = $(window).height(),
                scrollTop = $(window).scrollTop(),
                mid = scrollTop + Math.floor(windowHeight / 2); //- Math.floor(formHeight / 2);

            $(obj).css('top', mid + 'px').show();

            $(window).scroll(function (e) {
                let scrollTop = $(window).scrollTop(),
                    mid = scrollTop + Math.floor(windowHeight / 2); //- Math.floor(formHeight / 2);
                    $(obj).css('top', mid + 'px')
            });
                    
        },

        //activate from outside :highChart_graph_comparison_search.js
        setMaxSymbols: function (n) {
            let num = !isNaN(n) ? parseInt(n) : null;
            if (num > 0)
                this.maxSymbols = num;
        },


        unselectCompareButton: function (isToCloseAll) {
            if (isToCloseAll || this.symbols.length == 1)
                $(".indicatorsAndCompare .compare").removeClass("selected");
            if (typeof searcher != 'undefined') {
                searcher.cleanAndCloseHelpDiv();
            }
            $("#divGraphSearchBox").hide();
        },

        unselectIndicatorsButton: function (isToCloseAll) {
            if (isToCloseAll || this.indicatorsParams.length == 0)
                $(".indicatorsAndCompare .indicators").removeClass("selected");
            if (chart != undefined && this.indicatorsParams.length == 0) {
                chart.update({
                    tooltip: {
                        share: true,
                        split: false
                    }
                })
            }
          
            $("#selIndicatorWraper").hide();
        },

        unSelectRangeButton: function(){
            this.rangeSelectorGetAll().removeClass('selected')            
        },

        unSelectResolutionButton: () => {
            $(".resolutionGroup .resolution").removeClass('selected')
        },


        updateInputs : (min, max) => {
            $("#txtMinDate").val(globesChart.timeToDate(min))
            $("#txtMaxDate").val(globesChart.timeToDate(max))
        },
                
        updateState: function (obj) {
            if( this.mode.saveState )
                this.localSessionSetValue('state', obj);
        },       

        unSelectTools: () => {
            $("section.tools span").removeClass('selected');
             $("#hidSelection").val('')
        },

        yAxis_add_new: function (name, id) {
            
            let firstSmallYAxis = chart.yAxis.find((item, index) => { return index > 1 && item.userOptions.id != "navigator-y-axis" && item.userOptions.visible != false });


            let me = this,
                      plotHeight = chart.plotHeight,
                       mainAxis = chart.get('valueGraph'),
                       smallAxis = firstSmallYAxis, // chart.get('volumeGraph'),
                       mainYAxisHeight = mainAxis.height,
                       mainYAxisTop = mainAxis.top,
                       smallHeight = smallAxis === undefined ? me.defaultSmallChartHeightPercent * plotHeight : smallAxis.height,
                       smallTop = smallAxis === undefined ? me.defaultSmallChartTopPercent * plotHeight : smallAxis.top,
                       distanceHeight = smallTop - mainYAxisHeight - mainYAxisTop,

                       extraHeight = smallHeight + distanceHeight,
                       newChartHeight = chart.chartHeight + extraHeight,
                       newChartHeightPercent = (newChartHeight / chart.chartWidth * 100),
                       newPlotHeight = (chart.plotHeight + extraHeight),

                       newDistanseHeightPercent = (distanceHeight / newPlotHeight * 100),
                       newSmallHeightPercent = (smallHeight / newPlotHeight * 100);


                       let y_axis_id = name + chart.yAxis.length;
                       let yAxis = {
                            id: y_axis_id,
                            title: {
                                text: name
                            },
                            opposite: false,
                            top:  (100 - newSmallHeightPercent ) + '%',
                            height: newSmallHeightPercent + '%',
                            offset: 1,
                            
                            endOnTick: true,
                            showLastLabel: true,  
                            crosshair: {
                                snap: false,
                                dashStyle: 'Dash',
                                width: 1,                                
                            },
                            tickPixelInterval: 10,
                            tickLength: 4,
                            tickPosition: 'inside',
                            labels: {
                                formatter: function() {
                                    var ret,
                                        numericSymbols = ['k', 'M', 'G', 'T', 'P', 'E'],
                                        i = 6;
                                    if(this.value >=1000) {
                                        while (i-- && ret === undefined) {
                                            multi = Math.pow(1000, i + 1);
                                            if (this.value >= multi && numericSymbols[i] !== null) {
                                                ret = (this.value / multi) + numericSymbols[i];
                                            }
                                        }
                                    }
                                    return  (ret ? ret : this.value);
                                }
                            },
                        }
                        chart.addAxis(yAxis, false, false, true);
                        this.yAxisOptions.push(yAxis); ////tracking the yAxis

                this.yAxis_refresh(newPlotHeight, newDistanseHeightPercent, newSmallHeightPercent, newChartHeightPercent);
                return y_axis_id;

        },
        
        yAxis_remove: function (yAxisId) {
                let firstSmallYAxis = chart.yAxis.find((item, index) => { return index > 1 && item.userOptions.id != "navigator-y-axis" && item.userOptions.visible != false });
                let plotHeight = chart.plotHeight,
                       mainAxis = chart.get('valueGraph'),
                       smallAxis = firstSmallYAxis, //chart.get('volumeGraph'),
                       mainYAxisHeight = mainAxis.height,
                       mainYAxisTop = mainAxis.top,
                       smallHeight = smallAxis.height,
                       smallTop =  smallAxis.top,
                       distanceHeight = smallTop - mainYAxisHeight - mainYAxisTop,
                   

                       removedHeight = smallHeight + distanceHeight,
                       newChartHeight = chart.chartHeight - removedHeight,
                       newChartHeightPercent = (newChartHeight / chart.chartWidth * 100),
                       newPlotHeight = (chart.plotHeight - removedHeight),

                       newDistanseHeightPercent = (distanceHeight / newPlotHeight * 100),
                       newSmallHeightPercent = (smallHeight / newPlotHeight * 100);

                chart.get(yAxisId).remove();

                //tracking the yAxis
                let yAxisIndex = this.yAxisOptions.findIndex((obj) => { return obj.id == yAxisId });
                if (yAxisIndex > -1) {
                    this.yAxisOptions.splice(yAxisIndex, 1);
                }

                this.yAxis_refresh(newPlotHeight, newDistanseHeightPercent, newSmallHeightPercent, newChartHeightPercent);
               
        },
        
        yAxis_refresh: function (newPlotHeight, newDistanceHeightPercent, newSmallHeightPercent, newChartHeightPercent) {
            
            let arrHP = [],
                smallGraphCounter = 0;

            chart.yAxis.forEach(function (item, index) {
                let itemId = item.userOptions.id;

                if (itemId != 'navigator-y-axis' && item.visible != false) {
                    let height = item.height,
                            heightPercent = height / newPlotHeight * 100,
                            isMainAxis = itemId == 'valueGraph' || itemId == 'compare';  

                    arrHP.push(heightPercent);

                    if (isMainAxis) {
                        item.update({
                            height: heightPercent + '%',
                        });

                        let arrYItem = globesChart.yAxisOptions.find((y)=> { return y.id == itemId});
                        if(arrYItem != undefined){
                        	arrYItem.height = heightPercent + '%'
                        }

                    } else {
                       
                        smallGraphCounter++;
                        let totalDistanceHeightPresent = newDistanceHeightPercent * smallGraphCounter;
                        let sumPrevAxisHeight = arrHP.reduce(
                            (accumulator, currentValue, currentIndex, array) => {
                                return (currentIndex == array.length - 1 || currentIndex == 1) ? accumulator : accumulator + currentValue;
                            });
                        let top = totalDistanceHeightPresent + sumPrevAxisHeight;

                        item.update({
                            height: newSmallHeightPercent + '%',
                            top: top + '%'
                        });

                        let arrYItem = globesChart.yAxisOptions.find((y) => { return y.id == itemId });
                        if (arrYItem != undefined) {
                            arrYItem.height = newSmallHeightPercent + '%'
                            arrYItem.top = top + '%'
                        }
                        
                    }
                }
            });

            chart.setSize(undefined, newChartHeightPercent + '%');
            this.chartHeight = newChartHeightPercent + '%';
            chart.render()

        },

        
}


$(function () {

    if (typeof window.globesChart == 'undefined')
        window.globesChart = globesChart;

    if (typeof searcher != 'undefined') {
        searcher.init(globesChart);

        window.onresize = searcher.hideGraphHelpDiv;
        let formName = fName != undefined ? fName : 'aspnetForm';
        document.getElementById(formName).onsubmit = searcher.getGraphEnter;
        if (Mode != 'comparison') {
            $("#query_for_graph").blur(function() { searcher.OnBlurGraphText() });
            $("#query_for_graph").click(function() { searcher.hideGraphHelpDiv() });
            $("#query_for_graph").keypress(function(event) { searcher.getGraphEnter(event) });
            $("#query_for_graph").keyup(function(event) { searcher.UpdateSymboles(globesChart.symbols); searcher.onGraphSearchKeyUp(event) });
        }
    }

    globesChart.buildIndicatoresArray();

    $(".graphFrame").click(function() {
        if (typeof searcher != 'undefined') {
            globesChart.unselectCompareButton()
        }
        globesChart.unselectIndicatorsButton();

    });

    $(".indicatorsAndCompare .indicators").click(function (e) {
        e.stopPropagation()
        if (typeof searcher != 'undefined') {
            globesChart.unselectCompareButton(true);
        }
        $(this).addClass("selected");

        if (chart) {           
            let seriesLength = chart.series.filter((item) => item.options.id != 'volume' && item.options.id != 'highcharts-navigator-series').length;
            let graphTypeId = $("#hidGraphTypeId").val();
            let iGraphTypeId = typeof (graphTypeId) != undefined ? parseInt(graphTypeId) : 0;
            if (globesChart.arrNoVolumeGraph.indexOf(iGraphTypeId) > -1) {
                $("#selIndicatorWraper ul li[data-value='ad']").hide();
            } else {
                $("#selIndicatorWraper ul li[data-value='ad']").show();
            }

            $("#selIndicatorWraper").toggle()               
        }

        if (globesChart.tab != 'indicators') { //return to prev indicators
            globesChart.updateState({
                tab: 'indicators',
                type: 'candlestick'
            });
            let session = globesChart.localSessionRead();
            globesChart.restoreSession(session);
        }

         
    });

    $(".indicatorsAndCompare .compare").click(function (e) {
        e.stopPropagation()

        globesChart.unselectIndicatorsButton(true);

        if (chart) {
            let seriesLength = chart.series.filter((item) => item.options.id != 'volume' && item.options.id != 'highcharts-navigator-series').length;
                $(this).addClass("selected")
                $("#divGraphSearchBox").show();
                $("#query_for_graph").focus();                
        };

        if (Mode == '' && globesChart.tab != 'compare') { //return to prev compare 
            globesChart.updateState({
                tab: 'compare',
                type: 'line'
            });
            let session = globesChart.localSessionRead();
            globesChart.restoreSession(session);
        }
            
    });
    $(".indicatorsAndCompare .general").click(function (e) {
        e.stopPropagation();
        globesChart.updateState({
            tab: 'general'
        });
    });

    //graph type
    $(".graphType .lineGraph").click(function (e) {
        e.stopPropagation();
        globesChart.changeGraphTypeClick('line');
        
    });
    $(".graphType .candleGraph").click(function (e) {
        e.stopPropagation();
        globesChart.changeGraphTypeClick('candlestick');
        
    });

    //buttons

    //download
    $("#iconDownload").click(function (e) {
        e.stopPropagation()  
        
        if (Mode == 'small') {
            searcher.toExcel(instrumentid, feeder)
            return;
        }
        if (chart != undefined) {
            globesChart.setDialogPosition("section.downloadDialog");
            $("section.downloadDialog").show();
        }        
    });
    $("section.downloadDialog h2 span.close").click(function (e) {
        e.stopPropagation();
        $(window).off('scroll')
        $("section.downloadDialog").hide();
    });
    $("section.downloadDialog ul li").click(function (e) {        
        $(this).parent().find('li').removeClass('selected');
        $(this).addClass('selected');
    });
    $("section.downloadDialog div span.button").click(function (e) {        
        if ($(this).hasClass('ok')) {
            globesChart.defaultDownload = $("section.downloadDialog ul li.selected").attr('data-id');
            globesChart.updateState({
                defaultDownload: globesChart.defaultDownload
            })

            if (globesChart.defaultDownload == 'img') {
                if (chart)
                    chart.exportChart();
            } else {
                searcher.toExcel(instrumentid, feeder)
            }
        }   
        //} else {
            $("section.downloadDialog h2 span.close").click();
       // }
    });
    //--end download
    
    $("#iconFull").click(function (e) {
            e.stopPropagation()
            globesChart.iconFullToggle();           
        });
    $("#iconLight").click(function (e) {
            e.stopPropagation();  
            globesChart.changeTheme();
            if (Mode == 'comparison') {
                try {
                    searcher.changeTheme()
                } catch (e) { }
            }
                      
    });
    $("#iconReset").click(function (e) {
        e.stopPropagation(); 
        globesChart.localSessionClear();
        globesChart.initFirstTime();

        if (Mode == 'comparison') {
            try {
                searcher.reset()
            } catch (e) { }
        }
    });
    

        //range Selector
        $(".rangeSelectorLine .customRangeSelectorButtons .rangeSelector").click(function (e) {
            e.stopPropagation();  
            globesChart.isInputClick = false;
            globesChart.isResolutionClick = false;
            globesChart.isRangeSelectorClick = true;            

            let sType = $(this).attr("data-type"),
                sCount =  parseInt($(this).attr("data-count")),
                index = globesChart.rangeSelectorGetAll().index($(this));

            if (sType != 'custom') {
                globesChart.selResolution = undefined;
                $(".resolution").removeClass("selected")
            }
            
            $(this).parent().children().removeClass('selected')
            $(this).addClass('selected')
                        
            globesChart.rangeSelector = {
                type: sType,
                count: parseInt(sCount),
                selected: index,
            }
            if (sType == 'custom')
                return;

            if (chart == undefined)
                return;

            globesChart.afterRangeSelectorClick(e);

            if (Mode == 'comparison') {
                try {
                    searcher.changeRangeSelection(index)
                } catch (e) { }
            }
              
        });
        
        //resolutions
        $(".resolutionGroup .resolution").click(function (e) {
            e.stopPropagation();  
            $(".resolution").removeClass("selected")
            $(this).addClass("selected");
            
            globesChart.isResolutionClick = true;
            globesChart.isInputClick = false;
            globesChart.isRangeSelectorClick = false;
            

            let res = $(this).attr("data-res")
            let count = $(this).attr("data-count")
           // let count = res == 'minute' ? globesChart.minutes : 1;
            globesChart.selResolution = {
                res: res,
                count: count
            };

            globesChart.handleChangeResolution(res, count, this, true)
        });    

        //tools
        $("section.tools span").click(function () {
            let action = $(this).attr("data-action");
            $(this).parent().find("span").removeClass("selected");
            $(this).addClass("selected")
            $("#hidSelection").val(action);
        }); 
 
       

        $("#btnDelete").click(function () {
            $(this).parent().find("span").removeClass("selected");
            $(this).addClass("selected")
            //$("input[type='radio']:checked").prop("checked", false);
            $("#hidSelection").val('delete')
            if (chart != undefined) {
                let annotations = chart.annotations,
                    annotaion;

                if (annotations.allItems) {
                    for (let i = annotations.allItems.length - 1; i >= 0; i--) {
                        annotations.allItems[i].destroy();
                    }
                }
                   
            }
        });
   
        Highcharts.setOptions({
            lang: {
                thousandsSep: ',',
                months: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
                shortMonths:  ["ינו", "פבר", "מרץ", "אפר", "מאי", "יוני", "יולי", "אוג", "ספט", "אוק", "נוב", "דצמ"],// ["ינו", "פבר", "מרץ", "אפר", "מאי", "יוני", "יולי", "אוג", "ספט", "אוק", "נוב", "דצמ"],
                weekdays: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
                noData: 'אין מידע להצגה',
                loading: 'טוען מידע...',
            }
        });

        

        if (Mode == '') {
            (function (H) {
                //fix macd bug- can't remove graph when there are not enough points
                H.seriesTypes.macd.prototype.destroy = function () {
                    // this.graph is null due to removing two times the same SVG element
                    this.graph = null;
                    this.graphmacd = this.graphmacd && this.graphmacd.destroy();
                    this.graphsignal = this.graphsignal && this.graphsignal.destroy();

                    H.seriesTypes.sma.prototype.destroy.apply(this, arguments);
                };
            })(Highcharts);

            (function (H) {
                //fix macd not enough point - 
                H.wrap(H.seriesTypes.macd.prototype, 'getValues', function (proceed, series, params) {
                    if (series.xData.length < params.longPeriod + params.signalPeriod) {
                        return false;
                    } else {
                        return proceed.apply(this, Array.prototype.slice.call(arguments, 1));
                    }
                });
            })(Highcharts);

            (function (H) {

                if (H.seriesTypes.bb == undefined)
                    return;

                //set BB fill area attribute
                H.wrap(H.seriesTypes.bb.prototype, 'drawGraph', function (proceed) {
                    // Draw lines:
                    let bb = this,
                      newPathPart;

                    // proceed - run original
                    proceed.apply(this, [].slice.call(arguments, 1));

                    if (bb.options.fillColor) {
                        // custom - modify
                        newPathPart = (bb.gappedPath || bb.getGraphPath).call(bb); // get final path
                        newPathPart = newPathPart.join(' ').split(' ');
                        newPathPart[0] = 'L';
                        newPathPart.push('Z');

                        if (bb.graphtopLine) {
                            bb.graphtopLine.attr({
                                d: bb.graphtopLine.d + newPathPart.join(' '),
                                fill: bb.options.fillColor
                            });
                        }

                        if (bb.graphbottomLine) {
                            bb.graphbottomLine.attr({
                                d: bb.graphbottomLine.d + newPathPart.join(' '),
                                fill: bb.options.fillColor
                            });
                        }
                    }
                    

                });
            })(Highcharts);
        }
        if (Mode == 'articleComparison') {
            
            Highcharts.Axis.prototype.getSlotWidth = function() {
	            // Utility functions
                let each = Highcharts.each,
    	            isNumber = Highcharts.isNumber;
        
                let slotWidth,
    	            lastPxPos;
                each(this.tickPositions.slice(0, 5), function(pos) {
                    let pxPos
                    if (isNumber(pos)) {
                        pxPos = this.toPixels(pos);

                        if (isNumber(lastPxPos)) {
                            slotWidth = Math.max(slotWidth || 0, Math.abs(pxPos - lastPxPos));
                        }
                        lastPxPos = pxPos;
                    }
                }, this);
    
                return slotWidth - 10;
            }
        }

   

        //first draw according to session storage. if it's the first time or moving to wide/small screen
        let session = globesChart.localSessionRead(); //get state
       // globesChart.localSessionClear(); 

        if (session && globesChart.mode.saveState) {
            globesChart.restoreSession(session);           
        } else {            
            globesChart.initFirstTime();
        }

        if (Mode == '') {
            setTimeout(globesChart.setDatePickerDefault, 10);
        }

        try {
        if (g) { g.StopPageReload = true; }
    } catch (e) { }

        
});